
const translations = {
    "Notice!": "Bнимание!",
    "Are you sure that you want to delete this?": "Ты уверен, что хочешь удалить это?",
    "Confirm": "Подтвердить",
    "Cancel": "Отменить",
    "Min": "Мин",
    "Max": "Макс",
    "Before": "До",
    "After": "После",
    "w": "н",
    "week": "неделя",
    "weeks": "недель",
    "d": "д",
    "day": "день",
    "days": "день-/дней",
    "Due date": "Срок",
    "Start date": "Дата начала",
    "Internal date": "Внутренняя дата",
    "Notes": "Заметки",
    "Document": "Документ",
    "Email": "Электронная почта",
    "Billing": "Биллинг",
    "Add": "Добавить",
    "Archived": "Архивировано",
    "Cancelled": "Аннулировано",
    "Active": "Активный",
    "Inactive": "Неактивный",
    "Client company": "Компания-клиент",
    "General info": "Общая информация",
    "Digitisation of client documents": "Оцифровка клиентских документов",
    "Client portal": "Портал для клиентов",
    "Documents": "Документы",
    "Members": "Пользователи",
    "Preferences": "Настройки",
    "Yes": "Да",
    "No": "Нет",
    "Total hours": "Всего часов",
    "Extra hours": "Дополнительные часы",
    "Client": "Клиент",
    "Tasks": "Задачи",
    "Disable Uku’s task templates": "Отключи шаблоны задач Уку",
    "Set the estimation as time when the exact value is not entered": "Укажите в качестве временных затрат прогнозируемое время, если точное время не введено",
    "Checklist must be completed to finish the task": "Чеклист должен быть подтвержден для заврешения задачи",
    "Disable topic management for members": "Отключи управление темами для участников",
    "Disable time edit for members": "Отключить редактирование времени для пользователей",
    "Allow time entries in future": "Разрешить ввод времени в будущем",
    "Show all dependent tasks in the calendar": "Show all dependent tasks in the calendar",
    "Clients": "Клиенты",
    "Disable adding new clients for members": "Отключи добавление новых клиентов для членов клуба",
    "Only administrators can edit documents": "Редактировать документы могут только администраторы",
    "Allow digitisation of client documents": "Разреши оцифровать документы клиентов",
    "Use my Microsoft account": "Используйте мою учетную запись Microsoft",
    "Disconnect my Microsoft account": "Отключите мою учетную запись Microsoft",
    "Connect my Microsoft account": "Подключите мою учетную запись Microsoft",
    "Use my google account": "Используй мой аккаунт в google",
    "Connect my google account": "Подключи мой аккаунт google",
    "Disconnect my google account": "Отключите мой аккаунт google",
    "Emails": "Электронные письма",
    "Daily agenda": "Обзор дня",
    "Unread notifications": "Непрочитанные уведомления",
    "Task assigned to me": "Мне направлена задача",
    "Weekly summary": "Итоги недели",
    "Monthly summary": "Итоги месяца",
    "Updates and tips": "Обновления и рекомендации",
    "Overdue": "Просрочено",
    "1 day": "1 день",
    "1 day overdue": "1 день просрочки",
    "{0} days": "{0} рабочих дней",
    "{0} days overdue": "{0} дней просрочки",
    "{0} minute ago": "{0} минуту назад",
    "{0} minutes ago": "{0} минут назад",
    "{0} hour ago": "{0} час назад",
    "{0} hours ago": "{0} часов назад",
    "Sunday": "Воскресенье",
    "Monday": "Понедельник",
    "Tuesday": "Вторник",
    "Wednesday": "Среда",
    "Thursday": "Четверг",
    "Friday": "Пятница",
    "Saturday": "Суббота",
    "Sun": "Вс",
    "Mon": "Пон",
    "Tue": "Вт",
    "Wed": "Ср",
    "Thu": "Чт",
    "Fri": "Пт",
    "Sat": "Сб",
    "January": "Январь",
    "February": "Февраль",
    "March": "Март",
    "April": "Апрель",
    "May": "Май",
    "June": "Июнь",
    "July": "Июль",
    "August": "Август",
    "September": "Сентябрь",
    "October": "Октябрь",
    "November": "Ноябрь",
    "December": "Декабрь",
    "Jan": "Янв",
    "Feb": "Фев",
    "Mar": "Мар",
    "Apr": "Апр",
    "Jun": "Июнь",
    "Jul": "Июль",
    "Aug": "Авг",
    "Sep": "Сен",
    "Oct": "Окт",
    "Nov": "Ноя",
    "Dec": "Дек",
    "Today": "Сегодня",
    "Yesterday": "Вчера",
    "Day": "День",
    "Days": "Дни",
    "+{0} d": "+{0} д",
    "+{0} wd": "+{0} рд",
    "Weekly {0}": "Еженедельно {0}",
    "Every {0}. week {1}": "Каждую {0}. неделю {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Ежемесячно {0}. d",
    "Every {0}. month {1}. d": "Каждый {0}. месяц {1}. г",
    "{0}. d": "{0}. д",
    "Quarterly {0}. month {1}. d": "Квартал {0}. месяц {1}. г",
    "Every {0}. quarter {1}. month {2}. d": "Каждый {0}. квартал {1}. месяц {2}. г",
    "{0}. month {1}. d": "{0}. месяц {1}. д",
    "Yearly {0}": "Ежегодно {0}",
    "Every {0}. year {1}": "Каждый {0}. год {1}",
    "Mo": "Пн",
    "Tu": "Вт",
    "We": "Ср",
    "Th": "Чт",
    "Fr": "Пт",
    "Sa": "Сб",
    "Su": "Воскр",
    "and": "и",
    "{0}w": "{0}w",
    "{0}d": "{0}d",
    "before": "перед",
    "after": "после",
    "Project": "Проект",
    "Quarter": "Квартал",
    "Add your photo": "Добавь свою фотографию",
    "Adding file failed": "Загрузка файла не удалась",
    "Please check the file.": "Пожалуйста, проверьте файл.",
    "You can only add pictures.": "Можно добавить только фотографии.",
    "Error": "Ошибка",
    "Create new topic": "Создай новую тему",
    "Name": "Имя",
    "Close": "Закрыть",
    "Find topic...": "Найди тему...",
    "New topic": "Новая тема",
    "Invalid format": "Неправильный формат",
    "Demo company account": "Демо-счет компании",
    "Demo account will be deleted later. Do this for testing purposes only!": "Демо-счет будет удален позже. Делай это только в целях тестирования!",
    "Subscribe": "Подписаться",
    "Start demo": "Начни демо",
    "End demo": "Завершить демо",
    "Free trial is expired - {0}": "Срок действия бесплатной пробной версии истек - {0}",
    "Free trial {1} {2} left - {0}": "Бесплатная пробная версия {1} {2} слева - {0}",
    "Add time": "Добавить время",
    "Billable": "Оплачиваемый",
    "Date": "Дата",
    "Start": "Начало",
    "End": "Конец",
    "Duration": "Продолжительность",
    "Split duration equally": "Разделите продолжительность поровну",
    "Required field": "Обязательное поле",
    "Members list": "Список участников",
    "Edit fields": "Редактировать поля",
    "Maximum number of selected columns has been exceeded": "Превышено максимальное количество выбранных колонок",
    "If you want to add a new column to the report, please remove an existing one first.": "Если ты хочешь добавить в отчет новую колонку, сначала удали существующую.",
    "Snooze until...": "Дремать, пока...",
    "Select date & time": "Выберите дату и время",
    "Tomorrow": "Завтра",
    "Later this week": "Позже на этой неделе",
    "Next week": "Следующая неделя",
    "Add task": "Добавить задачу",
    "Checklist": "Чеклист",
    "Start timer": "Стартовый таймер",
    "Add an item": "Добавить пункт",
    "Add checklist item": "Добавьте элемент контрольного списка",
    "Convert to a task": "Преобразование в задачу",
    "Delete": "Удалить",
    "Delegate to...": "Делегируй...",
    "Please select tasks from the same account": "Выберите задания из одного аккаунта",
    "Follow": "Подписаться",
    "Expand sidebar": "Разверни боковую панель",
    "Nicely done!": "Отлично сделано!",
    "You've finished all your tasks, take a second to recharge": "Ты выполнил все свои задачи, удели секунду на подзарядку",
    "Search tasks...": "Поисковые задания...",
    "Search": "Поиск",
    "select/unselect all": "выбрать/отменить выбор всех",
    "Add new client": "Добавить нового",
    "Account": "Аккаунт",
    "Client name": "Заказчик",
    "Select client": "Выберите клиента",
    "New client": "Новый клиент",
    "Must be an integer": "Значение должно быть integer",
    "Must be a number": "Это должно быть число",
    "Dashboard": "Панель управления",
    "Calendar": "Календарь",
    "Report": "Отчет",
    "Monitoring": "Мониторинг",
    "Suppliers": "Поставщики",
    "Events": "События",
    "Projects": "Проекты",
    "Help": "Помощь",
    "Settings & Apps": "Настройки и приложения",
    "Profile": "Профиль",
    "Collapse menu": "Свернуть меню",
    "Expand menu": "Развернуть меню",
    "Are you sure to delete this attachment?": "Ты уверен, что можешь удалить это вложение?",
    "Select": "Выбрать",
    "Edit contacts": "Редактировать контакты",
    "Add member": "Добавить участника",
    "Add note": "Добавить заметку",
    "Open": "Open",
    "Reports": "Отчеты",
    "Billing notes": "Заметки о счетах",
    "Pinned notes": "Закрепленные заметки",
    "Sub-companies": "Субкомпании",
    "Contacts": "Контакты",
    "Event info": "Информация о событии",
    "Project info": "Информация о проекте",
    "Summary": "Резюме",
    "Task": "Задача",
    "Time": "Время",
    "Collapse sidebar": "Свернуть боковую панель",
    "Client Overview": "Обзор клиентов",
    "Event Overview": "Обзор события",
    "Project Overview": "Обзор проекта",
    "Edit client": "Редактируй клиента",
    "Edit event": "Редактировать событие",
    "Edit project": "Редактировать проект",
    "Show all": "Показать все",
    "Collapse": "Свернуть",
    "by": "от",
    "View all": "Посмотреть все",
    "Add company event": "Добавьте событие компании",
    "Company": "Компания",
    "Info": "Инфо",
    "Holiday": "Выходной",
    "All day(s)": "Весь день (дни)",
    "End date": "Дата окончания",
    "From": "От",
    "Until": "Окончание",
    "Hours": "Часов",
    "Link": "Ссылка",
    "Save": "Сохранить",
    "Are you sure that you want to delete this company calendar event?": "Ты уверен, что хочешь удалить это событие из календаря компании?",
    "Location of client folder in your document management system": "Location of client folder in your document management system",
    "Defined main folder": "Defined main folder",
    "Custom folder": "Custom folder",
    "Add new role": "Добавление новой роли",
    "New role": "Новая роль",
    "Access enabled": "Доступ разрешен",
    "Waiting for files": "В ожидании файлов",
    "Uploaded": "Загружено",
    "Uploading...": "Загрузка...",
    "Client members": "Члены клуба",
    "Email settings": "Настройки Email",
    "Or connect new email address": "Или подключи новый адрес электронной почты",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Подключись к Microsoft Exchange или другому почтовому серверу (SMTP)",
    "Test email sent": "Тестовое письмо отправлено",
    "Email address": "Адрес электронной почты",
    "Reply address": "Адрес ответа",
    "Sender name": "Имя отправителя",
    "Who can use?": "Кто может использовать?",
    "Client default address": "Адрес клиента по умолчанию",
    "Invalid e-mail": "Неверный адрес электронной почты",
    "Role": "Роль",
    "E-mail": "Электронная почта",
    "Mobile phone": "Мобильный телефон",
    "Work phone": "Рабочий телефон",
    "Language": "Язык",
    "Birthday": "День рождения",
    "Are you sure to delete this contact?": "Ты уверен, что хочешь удалить этот контакт?",
    "Manage contact fields": "Управляй полями контактов",
    "Administrative Assistant": "Административный помощник",
    "Board member": "Член совета директоров",
    "CEO": "Директор",
    "Add contact": "Добавить контакт",
    "Contact person": "Контактное лицо",
    "Leave page?": "Покинуть страницу?",
    "Changes that you made may not be saved": "Изменения, которые вы внесли, могут не сохраниться",
    "Leave": "Покинуть",
    "Super! We're importing your clients...": "Супер! Мы импортируем твоих клиентов...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Не стесняйся покинуть эту страницу. Мы вышлем уведомление, когда импорт будет подготовлен. Затем тебе нужно будет подтвердить клиентов, которых ты хочешь добавить в Uku.",
    "Please wait...": "Пожалуйста, подождите...",
    "Setup API keys": "Настройка ключей API",
    "You have two options": "У тебя есть два варианта",
    "how to setup API keys": "как настроить ключи API",
    "Continue": "Продолжить",
    "Custom import": "Пользовательский импорт",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Чтобы импортировать клиентов и объем работы из !INTEGRATION, Uku нужен API-ключ !INTEGRATION для каждого клиента.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Продолжение</span> - Uku автоматически создает ключи API для каждого клиента",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Пользовательский импорт</span> - Uku подключается только с существующими ключами UKU API. Перед импортом создай API-ключи вручную в !INTEGRATION. Читай:",
    "(it takes a lot of time)": "(Это занимает много времени)",
    "Import Clients": "Импортные клиенты",
    "Country": "Страна",
    "Please choose your country": "Выбери свою страну",
    "Password": "Пароль",
    "Start import": "Начать импорт",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Введи данные для входа в !INTEGRATION (это безопасно), чтобы получить одноразовый доступ к клиентам импорта и ключам API. Обрати внимание, что в других браузерах ты будешь выходить из !INTEGRATION.",
    "Update invoice status": "Обновление статуса счета",
    "Update now": "Обновить сейчас",
    "Daily @ 14:00": "Ежедневно в 14:00",
    "Daily @ 18:00": "Ежедневно @ 18:00",
    "Updating invoice statuses, please wait...": "Обновление статусов счетов, пожалуйста, подождите...",
    "Your import is ready": "Твой импорт готов",
    "In the final step you need to confirm the clients you want to add to uku": "На последнем этапе тебе нужно подтвердить клиентов, которых ты хочешь добавить в uku",
    "Let's go": "Поехали",
    "Import again": "Импортируй снова",
    "Do you have new clients to import?": "У тебя есть новые клиенты, которых нужно импортировать?",
    "Yes, i do": "Да, это так",
    "View last import": "Просмотр последнего импорта",
    "Email server": "Сервер электронной почты",
    "Email provider": "Поставщик электронной почты",
    "Host": "Хост",
    "Port": "Порт",
    "Security": "Безопасность",
    "Sender email": "Электронная почта отправителя",
    "Username": "Имя пользователя",
    "Test connection": "Проверить соединение",
    "How to set up": "Как настроить",
    "Only administrators can activate the app": "Активировать приложение могут только администраторы",
    "You are in the waiting list": "Ты в списке ожидания",
    "We onboard all applicants one by one": "Мы принимаем на работу всех кандидатов по очереди",
    "Connected": "Соединено",
    "Activated": "Активировано",
    "Join waiting list": "Присоединяйся к списку ожидания",
    "Activate": "Активировать",
    "Unsubscribe from waiting list": "Отказаться от подписки на список ожидания",
    "Deactivate app": "Деактивируй приложение",
    "Disconnect": "Отключить",
    "Hide expanded content": "Скрыть развернутый контент",
    "Show trimmed content": "Показать сокращенный контент",
    "Email not delivered": "Электронная почта не доставлена",
    "Sent, but fallback to Uku email": "Отправлен, но возврат к электронной почте Uku",
    "Unknown error": "Неизвестная ошибка",
    "to": "в",
    "in any minute": "в любую минуту",
    "on {0},": "на {0},",
    "or": "или",
    "Send now": "Отправить сейчас",
    "Uku <span class='subtitle-2'>is sending</span> email": "Уку <span class='subtitle-2'>отправляет</span> электронную почту",
    "__From_email": "__From_email",
    "Set up email": "Настройте электронную почту",
    "Client default": "Клиент по умолчанию",
    "Subject": "Тема",
    "Edit email": "Редактирование подписчика",
    "Template": "Шаблон",
    "Cc": "Копия",
    "Bcc": "Скрытая копия",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Добавить шаблон",
    "Add automation": "Добавь автоматизации",
    "Add placeholder": "Добавьте заполнитель",
    "Format text": "Форматируй текст",
    "Add attachment": "Добавить вложение",
    "Send": "Отправить",
    "Save automation": "Сохранить автоматизацию",
    "Choose email template": "Выберите шаблон письма",
    "All languages": "Все языки",
    "No templates found.": "Шаблоны не найдены.",
    "Edit email template": "Изменить шаблон Почты",
    "Are you sure you want to delete this template? Some tasks will be affected": "Ты уверен, что хочешь удалить этот шаблон? Некоторые задания будут затронуты",
    "Are you sure you want to delete this template?": "Вы уверены, что хотите удалить этот шаблон?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Ты уверен, что хочешь сохранить этот шаблон, ведь при этом будут затронуты следующие задачи?",
    "Template name": "Название шаблона",
    "Edit template": "Редактировать шаблон",
    "Send email": "Оправить письмо",
    "on": "вкл",
    "Ok": "Ок",
    "Supplier": "Поставщик",
    "Event": "Событие",
    "Contact": "Контакты",
    "Validation failed": "Проверка не удалась",
    "Saving supplier failed": "Спасти поставщика не удалось",
    "Saving client failed": "Не удалось сохранить клиента",
    "Saving project failed": "Сохранение проекта не удалось",
    "several values": "несколько значений",
    "values": "значения",
    "is": " ",
    "Add filter": "Добавить фильтр",
    "Update": "Обновить",
    "forever": "навсегда",
    "Last week": "Прошлая неделя",
    "This week": "Эта неделя",
    "Last month": "Прошлый месяц",
    "This month": "Этот месяц",
    "Next month": "Il prossimo mese",
    "Last year": "Прошлый год",
    "This year": "Этот год",
    "This quarter": "По кварталам",
    "Next quarter": "Следующая четверть",
    "Last quarter": "Последний квартал",
    "Client group": "Группа клиентов",
    "Topic": "Тема",
    "Member": "Участник",
    "Primary member": "Основной участник",
    "Client status": "Состояние клиента",
    "Active clients": "Активные клиенты",
    "Inactive clients": "Неактивные клиенты",
    "All": "Все",
    "Project status": "Статус проекта",
    "Member status": "Статус участника",
    "Active members": "Активные участники",
    "Limited members": "Ограниченные члены",
    "Inactive members": "Неактивные члены",
    "Contract status": "Статус контракта",
    "Active contracts": "Действующие контракты",
    "Pending contracts": "Невыполненные контракты",
    "Finished contracts": "Готовые контракты",
    "Contract template": "Шаблон контракта",
    "Payment recurrence": "Повторение оплаты",
    "Yearly": "Каждый год",
    "Monthly": "Ежемесячно",
    "Trial": "Пробный",
    "Region": "Регион",
    "Field": "Сфера",
    "All tasks": "Все задачи",
    "Todo": "Сделать",
    "Not done": "Не выполнено",
    "Done": "Готово",
    "Delayed": "Отложена",
    "Important": "Важное",
    "Extra work": "Дополнительная работа",
    "I Follow": "Я следую за",
    "Commented": "Комментировано",
    "Tracked time": "Отслеживаемое время",
    "Estimated": "Оценка",
    "Recurring task": "Повторяющееся задание",
    "Last import": "Последний импорт",
    "Period": "Период",
    "Client search": "Поиск клиентов",
    "Voucher": "Ваучер",
    "Company status": "Статус компании",
    "Deleted": "Удалено",
    "All status": "Все статусы",
    "Payment gateway": "Платежный шлюз",
    "All gateways": "Все шлюзы",
    "Uku manually": "Уку вручную",
    "Braintree": "Braintree",
    "Plan status": "Статус плана",
    "All plans": "Все планы",
    "Paid": "Оплачено",
    "Paid churn": "Платный отток",
    "Trial churn": "Пробный отток",
    "Plan period": "Плановый период",
    "All periods": "Все периоды",
    "Monthly plan": "Ежемесячный план",
    "Yearly plan": "Годовой план",
    "Company search": "Запрос информации из системы гос. регистра юр. Лиц",
    "User search": "Поиск пользователей",
    "Name key search": "Поиск по ключу имени",
    "None filter": "Нет фильтра",
    "OK": "ОК",
    "Start date cannot be later than due date": "Дата начала не может быть позже даты окончания срока",
    "tasks": "задачи",
    "task(s) had errors": "в задании (заданиях) были ошибки",
    "tasks selected": "выбранные задания",
    "Postpone": "Отложить",
    "Mark done": "Решена",
    "Hide multiselect": "Скрыть мультиселект",
    "Delete task(s)": "Удалите задание(я)",
    "All of the data related to the task will be deleted": "Все данные, связанные с заданием, будут удалены",
    "Some tasks include other people. Are you sure you want to delete?": "В некоторых заданиях участвуют другие люди. Ты уверен, что хочешь удалить?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Время было отслежено для некоторых из выбранных видов деятельности. Ты уверен, что хочешь удалить?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Время было отслежено на некоторые из выбранных видов деятельности. Некоторые задачи включают в себя других людей. Ты уверен, что хочешь удалить?",
    "task(s) were not marked done": "задание(я) не было отмечено выполненным",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Проверь, заполнен ли чек-лист или введено ли время, и закреплены ли они за тобой",
    "task(s) were not deleted": "задание(я) не было удалено",
    "task(s) time was not updated": "время выполнения задания не было обновлено",
    "Please make sure that you can add time to task": "Убедись, что ты можешь добавить время к заданию",
    "invoice table row": "строка таблицы счетов-фактур",
    "invoice table row(s) had errors": "в строке(ах) таблицы счетов-фактур были ошибки",
    "invoice table row(s) selected": "выбранная строка(ы) таблицы счетов-фактур",
    "Create": "Создать",
    "Mark paid": "Марка оплачена",
    "Send to client": "Отправь клиенту",
    "Recalculate": "Пересчитать",
    "Export to {0}": "Экспортируй в {0}",
    "Update Status from {0}": "Обновление статуса с {0}",
    "Void invoice": "Аннулировать счет-фактуру",
    "Delete invoice": "Удалить счет",
    "Restore invoice": "Восстановление счета",
    "Mark unpaid": "Марк неоплаченный",
    "Invoices": "Счета",
    "Download to Excel": "Загрузите в Excel",
    "Revenue split": "Разделение доходов",
    "Tax": "Налог",
    "Description": "Описание",
    "Percent": "Процент",
    "Integration Id": "Ид интеграции",
    "Integration Code": "Интеграционный код",
    "Name on invoice": "Имя на счете",
    "Restore": "Восстановить",
    "Archive": "Архив",
    "Hide": "Скрыть",
    "Are you sure?": "Вы уверены?",
    "Import finished!": "Импорт закончен!",
    "Failed to import {0} records": "Не удалось импортировать {0} записей",
    "Download report": "Скачать отчет",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Результат: добавлено {0}, обновлено {1}, пропущено {2}, не удалось импортировать {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Результат: добавлено {0}, обновлено {1}, пропущено {2}",
    "What’s next?": "Что дальше?",
    "To work effectively with your client base, complete the following steps:": "Чтобы эффективно работать со своей клиентской базой, выполни следующие шаги:",
    "Read more ›": "Читать далее '",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Далее ты будешь видеть только активных импортированных клиентов. Чтобы увидеть всех клиентов, удали фильтр \"Последний импорт\".",
    "View clients": "Просмотреть клиентов",
    "Add <b>primary member</b> to every client.": "Добавь <b>основного члена</b> к каждому клиенту.",
    "Add <b>task plan</b> to automate recurring tasks.": "Добавь <b>план задач</b>, чтобы автоматизировать повторяющиеся задания.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Настрой автоматическое ежемесячное подведение итогов в приложении {0} в Uku, чтобы импортировать объем работы.",
    "Title": "Заголовок",
    "Field type": "Тип поля",
    "Field name": "Имя поля",
    "Group name": "Название группы",
    "Choices": "Выбор",
    "Type each choice on a separate line": "Напиши каждый вариант на отдельной строке",
    "Required": "Обязательно",
    "For all topics": "Для всех тем",
    "For specific topics": "Для конкретных тем",
    "Topics": "Темы",
    "Non-billable": "Не оплачиваемый",
    "Edit task custom field": "Редактирование пользовательского поля задачи",
    "Add task custom field": "Добавьте пользовательское поле задачи",
    "Edit client custom field": "Редактирование пользовательского поля клиента",
    "Add client custom field": "Добавьте пользовательское поле клиента",
    "Choice {0}": "Вариант {0}",
    "Are you sure that you want to delete this custom field?": "Вы уверены в том, что хотите удалить данное дополнительное поле?",
    "Warning!": "Предупреждение!",
    "This custom field is in use. Do you wish to archive it?": "Это пользовательское поле уже используется. Не хочешь ли ты заархивировать его?",
    "Reconnect": "Переподключиться",
    "Send test email": "Отправить тестовое письмо",
    "Email address or username": "Адрес электронной почты или имя пользователя",
    "Other": "Другое",
    "Set default email server for company": "Установите почтовый сервер по умолчанию для компании",
    "My default email": "Моя электронная почта по умолчанию",
    "Depends on": "Зависит от",
    "Todo - Blocking": "Todo - блокировка",
    "In progress - Blocking": "В процессе - блокировка",
    "In progress": "В процессе",
    "Client code": "Код клиента",
    "Primary user": "Основной пользователь",
    "Added date": "Добавлено",
    "Updated": "Обновлено",
    "Contract count": "Количество контрактов",
    "Integration": "Интеграция",
    "No data available": "Нет данных",
    "No results found": "Результатов не найдено",
    "Loading": "Загрузка",
    "Sort by": "Сортировать по",
    "Rows per page": "Строк на страницу",
    "{0}-{1} of {2}": "{0}-{1} из {2}",
    "Ongoing": "Текущие",
    "important": "важное",
    "Read more": "Читать далее",
    "Add to previous time entry": "Добавить к предыдущей записи времени",
    "Add to next time entry": "Добавить к следующей записи времени",
    "Add new task": "Добавить новую задачу",
    "Cut previous time entry": "Прервать предыдущий ввод времени",
    "Cut next time entry": "Вырезать следующую временную запись",
    "Missing time entry": "Отсутствие записи о времени",
    "Overlapping time entries": "Пересекающиеся временные записи",
    "Member from custom fields": "Член из пользовательских полей",
    "Delegated to": "Делегировано",
    "Delegated by": "Делегировано",
    "Visible members": "Видимые члены",
    "Member type": "Тип участника",
    "Groups": "Группы",
    "Custom field": "Настраиваемое поле",
    "Contact search": "Поиск контактов",
    "Task start": "Начало выполнения задания",
    "Task due": "Задание выполнено",
    "Task finish": "Завершение задачи",
    "Custom date": "Настройка даты",
    "Never": "Никогда",
    "Agreed work is still expected": "Согласованная работа все еще ожидается",
    "Accepted flextime": "Принято использовать свободное время",
    "Declined flextime": "Отказался от свободного времени",
    "Cancelled flextime": "Отмененное свободное время",
    "Updated flextime": "Обновленный флекстайм",
    "Calendar deleted": "Календарь удален",
    "Calendar created": "Календарь создан",
    "Calendar approved": "Календарь утвержден",
    "Calendar declined": "Календарь отклонился",
    "Calendar updated": "Календарь обновлен",
    "Flextime balance updated": "Обновленный баланс свободного времени",
    "Flextime": "Flextime",
    "Vacation": "Отпуск",
    "Balance": "Баланс",
    "Comment": "Комментарий",
    "History": "История",
    "Action": "Действие",
    "Who": "Кто",
    "Take a vacation or mark an absence": "Возьми отпуск или отметь отсутствие",
    "Away": "Нет на месте",
    "Flextime bonus": "Бонус за свободное время",
    "Approver": "Утверждающий",
    "Vacation available": "Отпуск доступен",
    "Type": "Тип",
    "Reduce agreed working hours": "Сократить согласованные рабочие часы",
    "Reject": "Отклонить",
    "Approve": "Одобрить",
    "away_type_Away": "away_type_Away",
    "Sick leave": "Congedo per malattia",
    "Parental leave": "Отпуск по уходу за ребенком",
    "Working hours": "Working hours",
    "Mon-Fri, 40h weekly, 8h daily": "Mon-Fri, 40h weekly, 8h daily",
    "Customize": "Customize",
    "Total": "Итого",
    "Settings": "Настройки",
    "Work on holidays": "Работа в праздники",
    "Expand": "Развернуть",
    "Wait until event status": "Подожди, пока не наступит статус события",
    "Wait until project status": "Подожди, пока статус проекта",
    "Week(s)": "Неделя (недель)",
    "Day(s)": "Дней",
    "Rule": "Правило",
    "Depends on event": "Зависит от события",
    "Depends on project": "Зависит от проекта",
    "Due date in": "Срок исполнения ",
    "Status": "Статус",
    "Select event": "Выберите событие",
    "Select project": "Выберите проект",
    "Find event...": "Найдите событие...",
    "Find project...": "Найди проект...",
    "Custom recurrence": "Пользовательская повторяемость",
    "Every": "Каждый",
    "In case of holiday": "В случае отпуска",
    "Set time": "Установленное время",
    "Start time": "Время начала",
    "Repeat from": "Повторять начиная с",
    "Previous repeat from: {0}": "Предыдущий повтор от: {0}",
    "On date": "В день",
    "Plus days": "Плюс дни/-дней",
    "Due date time": "Срок исполнения",
    "Remove recurrence": "Отменить повторяемость",
    "Repeat": "Повторять",
    "month": "месяц",
    "quarter": "квартал",
    "year": "год",
    "1st month": "1-й месяц",
    "2nd month": "2-й месяц",
    "3rd month": "3-й месяц",
    "Day {0}": "{0}-й день",
    "Show before": "Покажи до",
    "Keep the day": "Сохрани день",
    "Show after": "Показать после",
    "From start date": "С момента начала",
    "From beginning of the month": "С начала месяца",
    "All days (Mon to Sun)": "Все дни (с пн по сб)",
    "Mon to Fri (incl. holidays)": "С пн по пт (включая праздники)",
    "Mon to Fri (excl. holidays)": "С пн по пт (за исключением праздников)",
    "1st": "1-ый",
    "2nd": "2-ой",
    "3rd": "3-ий",
    "Does not repeat": "Не повторяется",
    "Daily": "Ежедневно",
    "Weekly on {0}": "Неделя на {0}",
    "Monthly on day {0}": "Ежемесячно в день {0}",
    "Quarterly on {0} month {1} day": "Ежеквартально в {0} месяц {1} день",
    "Yearly on {0} {1}": "Ежегодно на {0} {1}",
    "Custom...": "Пользовательский ...",
    "Incorrect time": "Неправильное время",
    "Add repeat": "Добавь повтор",
    "Email added to queue": "Электронная почта добавлена в очередь",
    "Communication timeline": "График общения",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Активируй приложение Email App в App Store, чтобы отправлять автоматические письма и просматривать твои прошлые и будущие коммуникации в одном месте.",
    "Go to App Store": "Перейдите в App Store",
    "Unknown": "Неизвестно",
    "<b>Email</b> from": "<b>Электронная почта</b> ",
    "To": "Кому",
    "Planned": "Проектируемый",
    "Automated emails scheduled to be sent in the future": "Автоматические письма, запланированные к отправке в будущем",
    "Send e-mail": "Отправить электронное письмо",
    "Template unlinked": "Шаблон без ссылки",
    "Icon": "Иконка",
    "Link name": "Link name",
    "Link URL": "Link URL",
    "Open in new tab": "Open in new tab",
    "Visible": "Видимый",
    "External": "External",
    "Not external": "Not external",
    "Company default": "По умолчанию",
    "Not visible": "Not visible",
    "Use company default": "Use company default",
    "or choose icon": "or choose icon",
    "Find member...": "Найдите участника...",
    "I'll take it": "Принять задание",
    "Remove me": "Удалить меня",
    "Remove from task": "Снять с задания",
    "Learn more": "Узнать больше",
    "Company settings edit is disabled by owner": "Редактирование настроек компании отключено владельцем",
    "<b>Exported</b> {0} to {1}": "<b>Экспортировано</b> {0} в {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Отправлено клиент t</b> {0} от{1}",
    "<b>Paid {0}</b> {1}": "<b>Оплачено {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Аннулированно</b> {0}",
    "Do you wish to mark the task done for everyone?": "Отметить задание как “Выполнено” для всех пользователей?",
    "No, remove me": "Нет, убери только меня",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Задача не будет помечена как выполненная, но пользователь будет удален из списка исполнителей и добавлен в подписчики задачи",
    "Invalid email": "Неверный адрес электронной почты",
    "Accounting": "Бухгалтерский учет",
    "General": "Главное",
    "Advertising / Marketing/ PR": "Реклама / Маркетинг / PR",
    "Architecture": "Архитектура",
    "Construction": "Строительство",
    "Consulting - IT, software": "Консультация - ИТ, программное обеспечение",
    "Consulting - Management": "Консультация - управление",
    "Finance": "Финансы",
    "Legal": "Право",
    "Medicine / Pharmacy ": "Медицина / фармацевтика ",
    "Non-profit": "Недоходный",
    "Web design": "Веб-дизайн",
    "Web development": "Веб-разработка",
    "Max 140 characters": "Не более 140 символов",
    "Please complete the checklist": "Заполни контрольный список",
    "It is required to mark all checklist items as done": "Необходимо отметить все пункты чек-листа как выполненные",
    "Please enter time spent": "Пожалуйста, введите время, проведенное",
    "Inserting time is essential for this client": "Внесение времени является обязательным для этого клиента",
    "Only me": "Только я",
    "Private": "Частный",
    "Edit note": "Редактировать заметку",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Добавь дополнительную информацию о клиенте, например, особые соглашения, пароли и т.д.",
    "Edit": "Изменить",
    "Workdays": "Рабочие дни",
    "Workhours": "Рабочие часы",
    "Weeks": "Недель",
    "Clear filters": "Очистить фильтры",
    "Save filters": "Сохраняйте фильтры",
    "Expected": "Ожидаемый",
    "Estimation": "Продолжительность",
    "Do you also want to postpone the due date?": "Перенести срок исполнения?",
    "{0} week": "{0} неделя",
    "{0} weeks": "{0} недели",
    "Vacations": "Отпуск",
    "Holidays": "Праздники",
    "Tax dates": "Налоговые даты",
    "Accounting news": "Новости бухгалтерского учета",
    "Company events": "События в компании",
    "Member birthdays": "Дни рождения пользователей",
    "Contact birthdays": "Дни рождения контактных лиц",
    "Group items": "Сгруппировать задания",
    "Don't group": "Не группировать",
    "{0} away": "{0} отсутствует",
    "Member birthday | Member birthdays": "День рождения пользователя | День рождения пользователя",
    "Contact birthday | Contact birthdays": "День рождения контакта | День рождения контакта",
    "Contact birthday": "День рождения контактного лица",
    "Member birthday": "День рождения пользователя",
    "Are you sure you wish to delete this link?": "Ты уверен, что хочешь удалить эту ссылку?",
    "Reference name": "Название ссылки",
    "Reference link": "Ссылка",
    "Free trial": "Бесплатная пробная версия (trial)",
    "Solo": "Один",
    "Team": "Команда",
    "Enterprise": "Предприятие",
    "Mini Uku": "Мини Уку",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Плагин для браузера Chrome для Uku, позволяющий управлять задачами, клиентами и отслеживать время.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Настраивай планы задач/работ, чтобы автоматизировать рабочий процесс, добавляй темы, пользовательские поля и изменяй свои предпочтения.",
    "Setup client groups, custom fields and modify your preferences.": "Настраивай группы клиентов, пользовательские поля и изменяй свои предпочтения.",
    "test": "тест ",
    "Anti Money Laundering": "Борьба с отмыванием денег",
    "Setup your customer AML and get instant reminders when auditing is due.": "Настрой AML своих клиентов и получай мгновенные напоминания о наступлении срока аудита.",
    "flextime_description": "описание времени работы",
    "Smart Accounts": "Smart Accounts",
    "Automatically imports work statistics from your accounting software.": "Автоматически импортирует статистику работы из твоей бухгалтерской программы.",
    "Merit Aktiva": "Merit Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Процесс выставления счетов клиентам с помощью прейскуранта и смарт-контракта.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Визуальный отчет точно скажет тебе, насколько прибыльным или убыточным является твой клиент.",
    "Emailing description": "Описание по электронной почте",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Синхронизируй данные о клиентах из Uku в e-conomic и наоборот. Просматривай информацию из книги продаж по каждому клиенту.",
    "Xero": "Xero",
    "xero_description": "xero_description",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "quickbooks_description",
    "Tripletex": "Tripletex",
    "tripletex_description": "tripletex_description",
    "Scoro": "Scoro",
    "Export sales invoices.": "Экспортируй счета за продажу.",
    "Fortnox": "Fortnox",
    "fortnox_description": "fortnox_description",
    "Magic button": "Умные кнопки",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Один клик - быстрый и простой способ создания важных задач. Например, телефонный звонок от клиента.",
    "With suppliers, you make your projects and partners management more efficient.": "С помощью поставщиков ты сделаешь управление своими проектами и партнерами более эффективным.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Мощное и гибкое управление проектами обслуживает различные сценарии использования и рабочие процессы.",
    "client_portal_app_description": "client_portal_app_description",
    "Chat": "Чат",
    "chat_app_description": "chat_app_description",
    "Companies House": "Companies House",
    "companies_house_app_description": "companies_house_app_description",
    "documents_app_description": "documents_app_description",
    "Connect and discover tools to help you manage your business.": "Общайся и открывай для себя инструменты, которые помогут тебе управлять своим бизнесом.",
    "Subscribe now": "Подписаться сейчас",
    "Compare plans": "Сравнить тарифы",
    "Add company": "Добавить компанию",
    "BETA": "БЕТА",
    "Setup": "Установки",
    "Power up": "Улучшить",
    "Integrations": "Интеграции",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Привет! Хочешь работать с командой и использовать дополнительные возможности? Без проблем, сначала добавь свою компанию!",
    "Read more about Uku plans": "Подробнее о планах Уку",
    "Contact role": "Контактная роль",
    "Contact roles": "Роль контактного лица",
    "Client groups": "Группы клиентов",
    "Client fields": "Клиентские поля",
    "Contact fields": "Контактные поля",
    "View archive": "Посмотреть архив",
    "Restore from archive": "Восстановление из архива",
    "Empty list": "Пустой список",
    "Task fields": "Поля задач",
    "task topics": "темы заданий",
    "Keep the task opened when starting the timer": "Держи задачу открытой, когда запускаешь таймер",
    "task templates": "шаблоны заданий",
    "Author": "Автор",
    "Duplicate": "Дублировать",
    "Uku task templates": "Шаблоны заданий для Уку",
    "Are you sure that you want to delete this task template?": "Ты уверен, что хочешь удалить этот шаблон задания?",
    "Templates": "Шаблоны",
    "Overview": "Обзор",
    "chat_app_overview_text": "chat_app_overview_text",
    "Color": "Цвет",
    "Are you sure to delete this field? You may lose the data.": "Ты уверен, что нужно удалять это поле? Ты можешь потерять данные.",
    "Add field": "Добавить поле",
    "Add section": "Добавить секцию",
    "multiline": "многострочный",
    "Import data": "Импорт данных",
    "Automate data collection with Smart Accounts": "Автоматизируй сбор данных с помощью Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Импортируй записи о покупках и продажах, общее количество записей и количество строк записей;</li><li>Автоматизируй сбор данных с помощью Smart Accounts;</li><li>Более быстрое и точное выставление счетов благодаря автоматизированному обмену данными. Uku собирает информацию для подготовки счетов клиентов в одном месте и делает выставление счетов эффективным.</li></ul>",
    "xero_app_overview_text": "xero_app_overview_text",
    "Import clients from {0}": "Импортируй клиентов из {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Прежде чем импортировать клиентов, тебе нужно авторизоваться в Xero и выбрать компанию.",
    "Authorize Xero to start import": "Разрешите Xero начать импорт",
    "Failed to import clients": "Не удалось импортировать клиентов",
    "Failed to connect to WS": "Не удалось подключиться к WS",
    "Import": "Импорт",
    "emailing_app_overview_text": "emailing_app_overview_text",
    "Email signatures": "Email signatures",
    "Everyone": "Все",
    "Access": "Доступ",
    "Creator": "Автор",
    "Are you sure you want to delete this signature? Some emails will be affected": "Are you sure you want to delete this signature? Some emails will be affected",
    "Email addresses": "Email адреса",
    "Signatures": "Signatures",
    "Send emails": "Send emails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku надежно интегрируется с твоей электронной почтой, чтобы помочь тебе управлять коммуникациями и автоматизировать их",
    "Use {0} address": "Используй адрес {0}",
    "connect your email address": "подключи свой адрес электронной почты",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Подключись к Microsoft Exchange или другому почтовому серверу (SMTP)",
    "Email integration reconnected": "Интеграция электронной почты снова подключена",
    "Are you sure you want to delete this email integration?": "Ты уверен, что хочешь удалить эту почтовую интеграцию?",
    "Email templates": "Шаблоны email’а",
    "Add email template": "Добавить шаблон электронной почты",
    "Are you sure you want to save this template? Some tasks will be affected": "Ты уверен, что хочешь сохранить этот шаблон? Некоторые задания будут затронуты",
    "Clients can leave task messages by replying to client portal email": "Clients can leave task messages by replying to client portal email",
    "Send a copy of client's response to member's inbox": "Send a copy of client's response to member's inbox",
    "Email recipients can leave task comments by replying to a task email": "Email recipients can leave task comments by replying to a task email",
    "economic_app_overview_text": "экономическое_приложение_обзор_текст",
    "Default layout": "Макет по умолчанию",
    "Change agreement ID": "Изменить идентификатор соглашения",
    "Failed to connect to server": "Не удалось подключиться к серверу",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku импортирует всех клиентов, информацию о клиентах и классификаторы. На последнем этапе ты можешь выбрать, каких клиентов ты хочешь добавить или обновить.",
    "Connect e-conomic": "Подключи электронную экономику",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Прежде чем импортировать клиентов, тебе нужно соединить Uku и экономическое программное обеспечение. Для этого создай экономическое соглашение и введи здесь ID соглашения.",
    "Step {0}": "Шаг {0}",
    "Get agreement ID": "Получи идентификатор соглашения",
    "Insert agreement ID": "Вставьте идентификатор соглашения",
    "Connect": "Соединить",
    "quickbooks_app_overview_text": "quickbooks_app_overview_text",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku импортирует всех клиентов, информацию о клиентах и классификаторы из QuickBooks. На последнем этапе ты можешь выбрать, каких клиентов ты хочешь добавить или обновить.",
    "Before importing clients, you need to connect with QuickBooks.": "Прежде чем импортировать клиентов, тебе нужно подключиться к QuickBooks.",
    "Connected to QuickBooks": "Подключился к QuickBooks",
    "fortnox_app_overview_text": "fortnox_app_overview_text",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku импортирует всех клиентов, информацию о клиентах и классификаторы из Fortnox. На последнем этапе ты можешь выбрать, каких клиентов ты хочешь добавить или обновить.",
    "Before importing clients, you need to connect with Fortnox.": "Прежде чем импортировать клиентов, тебе нужно подключиться к Fortnox.",
    "Connect to Fortnox": "Подключись к Fortnox",
    "Connected to Fortnox": "Подключился к Fortnox",
    "Delete template": "Удалить шаблон",
    "Public": "Публичный",
    "Workflow templates": "Шаблоны рабочего процесса",
    "No workflow templates yet": "Шаблонов рабочих процессов пока нет",
    "Modified": "Модифицированный",
    "Uku workflow templates": "Шаблоны рабочего процесса Uku",
    "Are you sure you wish to delete this workflow?": "Ты уверен, что хочешь удалить этот рабочий процесс?",
    "Project fields": "Поля проекта",
    "Progress step": "Шаг прогресса",
    "Rename project": "Переименуй проект",
    "Project statuses": "Статусы проектов",
    "You can use the statuses to restrict the workflow.": "Ты можешь использовать статусы, чтобы ограничить рабочий процесс.",
    "Project phases": "Фазы проекта",
    "Make your progress beautiful.": "Оптимизируй процессы",
    "Permissions": "Разрешения",
    "Users can manage workflow templates": "Пользователи могут управлять шаблонами рабочих процессов",
    "project_app_overview_text": "project_app_overview_text",
    "project_app_overview_description": "project_app_overview_description",
    "Configure summary task": "Настройте суммарное задание",
    "Uku will generate task with following title and topic on the last day of the month.": "В последний день месяца Uku сгенерирует задание со следующим названием и темой.",
    "Task title": "Название задачи",
    "Recurrence": "Повторение",
    "Count changes from previous periods": "Изменения по сравнению с предыдущими периодами",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Если включено, то изменения, внесенные в предыдущие периоды, будут добавлены к текущему месяцу. Если отключить, то изменения, сделанные в предыдущих периодах, не будут учитываться.",
    "Configure data fields": "Настройте поля данных",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Выбери соответствующее поле Uku для каждого импортированного поля. Одинаковые поля будут суммироваться. Если оставить какое-то поле пустым, оно будет проигнорировано.",
    "New custom field": "Новое пользовательское поле",
    "Show more": "Показать больше",
    "Every month": "Каждый месяц",
    "Last day of the month": "Последний день месяца",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "День {0} следующего месяца",
    "Settings saved": "Настройки сохранены",
    "Uku will let you know when it is ready.": "Уку сообщит тебе, когда все будет готово.",
    "Reload data": "Перезагрузите данные",
    "months": "месяцев",
    "This will overwrite existing summary tasks new values.": "Это перезапишет существующие сводные задания новыми значениями.",
    "Overwrite": "Перезаписать",
    "Automate your anti money laundering process": "Автоматизируй процесс борьбы с отмыванием денег",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Ты собираешься активировать процесс борьбы с отмыванием денег. При этом в данные твоих клиентов будут добавлены новые дополнительные поля, а также система начнет напоминать тебе об их обновлении.<br><br>Дополнительные поля:<ul><li>Профиль риска</il><li>Профиль действителен до</il><li>AML Staus</il><li>Документ NO</il><li>Документ действителен до</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Ты собираешься активировать процесс борьбы с отмыванием денег. В ходе этого в данные твоих клиентов будут добавлены новые дополнительные поля, а также система начнет напоминать тебе об их обновлении.<br><br>Дополнительные поля:<ul><li>Профиль риска</il><li>Следующая проверка AML</il><li>Прошел/не прошел</il><li>Тип идентификатора</il><li>Номер идентификатора</il><li>Дата истечения</ul> срока действия<ul></il><li>Дополнительные проверки</li></ul>",
    "Do not change client custom fields created by Uku": "Не изменяй пользовательские поля клиента, созданные Uku",
    "day(s) before": "дней до",
    "Task name": "Название задачи",
    "Assigned": "Назначено",
    "Note": "Заметка",
    "Manual run": "Ручной запуск",
    "Create a task when the document expires": "Создать задачу при истечении срока действия документа",
    "Create a task when the risk profile must be updated": "Создать задачу, когда необходимо обновить профиль риска",
    "Flextime period": "Свободное время Flextime",
    "Confirmation period": "Confirmation period",
    "Weekly": "Еженедельно",
    "Add agreement": "Добавь соглашение",
    "flextime_app_overview_text": "flextime_app_overview_text",
    "supplier_app_overview_text": "supplier_app_overview_text",
    "supplier_app_overview_description": "supplier_app_overview_description",
    "Supplier type": "Тип поставщика",
    "Parent type": "Тип головного предприятия",
    "Edit supplier type": "Редактирование типа поставщика",
    "New supplier type": "Новый тип поставщика",
    "Are you sure you wish to delete this supplier type?": "Ты уверен, что хочешь удалить этот тип поставщика?",
    "Types": "Типы",
    "Supplier types": "Типы поставщиков",
    "No supplier types yet": "Типов поставщиков пока нет",
    "tripletex_app_overview_text": "tripletex_app_overview_text",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku импортирует всех клиентов, информацию о клиентах и классификаторы из Tripletex. На последнем этапе ты можешь выбрать, каких клиентов ты хочешь добавить или обновить.",
    "Connect Tripletex": "Соедини Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Прежде чем импортировать клиентов, тебе нужно соединить Uku и программу Tripletex. Для этого создай токен сотрудника и введи его здесь.",
    "Get employee token": "Получи токен сотрудника",
    "Insert employee token": "Вставьте маркер сотрудника",
    "Install": "Установить",
    "Open Chrome browser to install": "Открой браузер Chrome, чтобы установить",
    "Works with your online accounting software.": "Работает с твоей онлайн-программой для ведения бухгалтерского учета.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Новые задачи возникают неожиданно, и поэтому Mini Uku - твой лучший друг. Неважно, делаешь ли ты банковские переводы или работаешь в бухгалтерской программе; с помощью Mini Uku ты можешь добавлять новые задачи, отслеживать время и следить за всеми уведомлениями с любого сайта.<br><br>Всего один клик на иконку совы дает обзор всего твоего рабочего дня и помогает эффективнее планировать расписание.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "merit_aktiva_app_overview_text",
    "Import clients": "Испортировать клиентов",
    "documents_app_overview_text": "documents_app_overview_text",
    "Connect your existing document management system": "Connect your existing document management system",
    "Main folder": "Main folder",
    "Under this folder, Uku automatically creates folders for each client.": "Under this folder, Uku automatically creates folders for each client.",
    "You can customize each client folder separately under client settings.": "You can customize each client folder separately under client settings.",
    "Automatically create Public folder for client files and Private folder for member files": "Automatically create Public folder for client files and Private folder for member files",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Automatically create  Year / Month subfolder under each client for files sorting",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Automatically create  Notes and Templates subfolders under each client for files sorting",
    "Add task files added by Members": "Add task files added by Members",
    "Add task files added by Clients (from emails and client portal)": "Add task files added by Clients (from emails and client portal)",
    "Backup files to Uku file storage": "Backup files to Uku file storage",
    "Perfect example": "Perfect example",
    "You are about to disconnect this service.": "You are about to disconnect this service.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "Select folder": "Select folder",
    "Manage": "Manage",
    "Refresh": "Обновить",
    "Be aware of the issues before they become problems": "Будь в курсе проблем до того, как они станут проблемами",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Сравнивай в реальном времени контракт клиента и фактически выполненную работу;</li><li>Будь в курсе проблем до того, как они станут проблемами;</li><li>Даже при фиксированных ценах тебе необходимо иметь внутренние измерения. Контролируй действительность клиентского договора, сравнивая его с фактическим объемом выполненной работы.</li></ul>",
    "client_portal_app_overview_text": "client_portal_app_overview_text",
    "Branding": "Брендинг",
    "Subdomain": "Поддомен",
    "Default language": "Язык по умолчанию",
    "Client portal URL in other languages": "URL-адрес клиентского портала на других языках",
    "Copy URL": "Скопировать URL-адрес",
    "Trademark": "Товарный знак",
    "Trademark text color": "Цвет текста торговой марки",
    "Choose color": "Выберите цвет",
    "Brand background color": "Цвет фона бренда",
    "Logo": "Лого",
    "Delete logo": "Удалить логотип",
    "Upload logo file": "Загрузите файл с логотипом",
    "Max. dimensions 180 x 60 px": "Максимальные размеры 180 х 60 пикселей",
    "Favicon": "Favicon",
    "Delete icon": "Удалить иконку",
    "Upload icon file": "Загрузить",
    "Recommended size 260 x 260 px": "Рекомендуемый размер 260 x 260 px",
    "Company description": "Описание Компании",
    "Displayed on the login page.": "Отображается на странице входа в систему.",
    "Describe here what services you offer and how you help your clients.": "Опиши здесь, какие услуги ты предлагаешь и как помогаешь своим клиентам.",
    "Welcome video": "Приветственное видео",
    "Displayed on the login page when your client contact enters for the first time": "Отображается на странице входа в систему, когда твой клиент заходит в нее в первый раз",
    "Use Uku video": "Используй видео с Уку",
    "View": "Просмотр",
    "Use other video": "Используй другое видео",
    "Youtube or Vimeo video URL": "URL-адрес видео на Youtube или Vimeo",
    "Show file upload box for client tasks": "Показывай окно загрузки файлов для клиентских заданий",
    "Invalid data": "Неверные данные",
    "Client portal preview": "Предварительный просмотр клиентского портала",
    "Client portal URL for {0} copied to clipboard": "URL-адрес клиентского портала для {0} скопирован в буфер обмена",
    "Personalize your client portal's menu": "Personalize your client portal's menu",
    "Menu links saved": "Menu links saved",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>",
    "Menu links": "Menu links",
    "Add recurring task": "Добавьте повторяющуюся задачу",
    "Reminder tasks updated": "Обновленные задания-напоминания",
    "Create recurring tasks for Companies House clients.": "Создавай повторяющиеся задания для клиентов Companies House.",
    "companies_house_app_overview_text": "companies_house_app_overview_text",
    "buttons": "кнопки",
    "Show to me": "Покажи мне",
    "magic_button_app_overview_text": "magic_button_app_overview_text",
    "Buttons": "Кнопки",
    "Member rights": "Права участника",
    "Allow managers to view and create their client contracts and invoices": "Разрешаю менеджерам просматривать и создавать клиентские договоры и счета-фактуры",
    "Allow members to view and create their client invoices": "Разрешаю пользователям просматривать и создавать счета для своих клиентов",
    "Allow members to view their client invoices": "Разрешаю пользователям просматривать счета своих клиентов",
    "Allow only owners to add and update products": "Разреши только владельцам добавлять и обновлять продукты",
    "Allow members to send invoices to clients": "Разрешаю пользователям отправлять счета клиентам",
    "Allow members to confirm their client invoice rows": "Разрешаю пользователям подтверждать строки счета клиента",
    "Send PDF invoice": "Отправить счет PDF",
    "Invoice email": "Электронная почта счета-фактуры",
    "Default rounding": "Округление по умолчанию",
    "Round all times up to x": "Округли все времена до x",
    "Time rounding increment": "Инкремент округления времени",
    "Apply time rounding to": "Примени округление времени для",
    "Default configuration": "Конфигурация по умолчанию",
    "Invoice date": "Дата счета",
    "Invoice entry date": "Дата ввода счета-фактуры",
    "Bill tracked time by": "Выставить счет за отслеженное время по",
    "Bill task field by": "Выставить счет на основании поля ",
    "Create one invoice merging invoices from the same period": "Создай один счет, объединив счета за один и тот же период",
    "Invoices from the same period": "Счета за тот же период",
    "Hide zero sum lines": "Спрятать ряды с нулевой суммой",
    "By default, time entry is billable": "По умолчанию ввод времени является оплачиваемым",
    "Invoice number": "Номер счета",
    "Prefix": "Префикс",
    "Suffix": "Суффикс",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Настройки выставления счетов сохранены",
    "billing_app_overview_text": "billing_app_overview_text",
    "Products": "Товары",
    "Contract templates": "Шаблоны договоров",
    "Invoice templates": "Шаблоны счетов-фактур",
    "Tools": "Инструменты",
    "Replace tax": "Замените налог",
    "Old tax": "Старый налог",
    "New tax": "Новый налог",
    "Find tax": "Найти налог",
    "Replace VAT in products": "Замените НДС в продуктах",
    "Replace VAT in master contracts": "Замените НДС в генеральных контрактах",
    "Replace VAT in client contracts & draft invoices": "Замени НДС в договорах с клиентами и проектах счетов-фактур",
    "Replace VAT values": "Замените значения НДС",
    "This action cannot be undone": "Это действие не может быть отменено",
    "Replace": "Заменить",
    "Result": "Результат",
    "PDF templates": "Шаблоны PDF",
    "E-mail templates": "Шаблоны э-мейлов",
    "Edit PDF template": "Редактирование шаблона PDF",
    "Import classificators": "Импорт классификаторов",
    "products": "продукты",
    "product": "продукт",
    "Product / service": "Продукт / услуга",
    "Calculate": "Рассчитать",
    "Article": "Статья",
    "Resource": "Ресурс",
    "Cost center": "Центр затрат",
    "Taxes": "Налоги",
    "Code": "Код",
    "Source": "Источник",
    "Articles": "Статьи",
    "Resources": "Ресурсы",
    "Cost centers": "Центры затрат",
    "Units": "Единицы",
    "Unit": "Единица",
    "Bank accounts": "Банковский счет",
    "Bank account": "Банковский счёт",
    "Bank name": "Название банка",
    "IBAN": "IBAN",
    "SWIFT code": "Код SWIFT",
    "Do you wish to import only new data or also overwrite existing?": "Ты хочешь импортировать только новые данные или также перезаписать существующие?",
    "Only new": "Только новые",
    "New items will be added. Existing ones will remain unchanged by import.": "Новые услуги будут добавлены. Существующие останутся неизменными при импорте.",
    "Import everything": "Импортируй все",
    "Connect accounting service": "Подключи бухгалтерский сервис",
    "Service": "Услуга",
    "API ID": "ID приложения",
    "API key": "API ключ",
    "Company Account Id": "Идентификатор счета компании",
    "Api secret": "Api secret",
    "E-conomic": "E-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Тест",
    "Lock time entries": "Блокировка временных записей",
    "Owner rights": "Права владельца",
    "Disable company settings edit for all members": "Отключи редактирование настроек компании для всех участников",
    "Disable personal clients for members": "Отключи персональные клиенты для участников",
    "Show member birthdays": "Показать дни рождения участников",
    "Show contact birthdays": "Показать дни рождения контактов",
    "Weekly @ Sun {0}": "Weekly @ Sun {0}",
    "Monthly @ last day of month": "Ежемесячно @ последний день месяца",
    "Company event list": "Список мероприятий компании",
    "How long?": "Как долго?",
    "Invoice no.": "Номер счета.",
    "Login options": "Параметры входа в систему",
    "Tenant ID (optional)": "Идентификатор арендатора (необязательно)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Добавь идентификатор арендатора Active Directory, если подключение разрешено только пользователям, принадлежащим к этому арендатору",
    "How to find ID’s?": "Как найти удостоверения личности?",
    "Microsoft connected": "Подключенный Microsoft",
    "Google connected": "Подключенный Google",
    "Edit company": "Редактировать данные компании",
    "Timezone": "Часовой пояс",
    "VAT number": "Номер плательщика НДС",
    "Company number": "Рег. код",
    "Subscription plan": "План подписки",
    "Payment failed": "Платеж не прошел",
    "Retry payment": "Повторить оплату",
    "Next payment": "Следующий платеж",
    "Update payment method": "Обновите способ оплаты",
    "Plan": "План",
    "Choose a plan": "Выбрать тариф",
    "Change plan": "Изменить пакет",
    "{0}-day free trial until {1}": "{0}-дневная бесплатная пробная версия до {1}",
    "monthly": "ежемесячно",
    "yearly": "ежегодно",
    "{0} member": "{0} пользователь",
    "{0} members": "{0} членов",
    "{0} plan": "{0} план",
    "Cancelled (valid until {0})": "Отменено (действует до {0})",
    "Your trial expired on {0}": "Срок действия твоей пробной версии истек {0}",
    "Your subscription expired on {0}": "Срок твоей подписки истек {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Рад тебя видеть! Если ты хочешь начать работу с подпиской на Uku, нажми на кнопку Выбрать план",
    "Save {0} by paying for a year!": "Сэкономь {0}, заплатив за год!",
    "Choose plan": "Выберите план",
    "Pay annually": "Платить ежегодно",
    "Instructions sent!": "Инструкции отправлены!",
    "Instructions for resetting your password have been sent to": "Инструкции по восстановлению пароля были отправлены на адрес",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Ты получишь письмо в течение 5 минут. Не забудь проверить папку со спамом.",
    "Back to login page": "Обратно на страницу входа",
    "Get new password": "Получить новый пароль",
    "Pick a password": "Выбрать пароль",
    "Use minimum 8 characters with letters & numbers": "Используй минимум 8 символов с буквами и цифрами",
    "Create your Uku Account": "Создай свой аккаунт в Uku",
    "Connect your Xero Account": "Подключи свой аккаунт Xero",
    "Phone": "Телефон",
    "I agree to the": "Я согласен с",
    "Terms of Service": "Условия пользования",
    "Next": "Следующий",
    "Having trouble?": "Возникли проблемы?",
    "We can help": "Мы можем помочь",
    "Log in instead": "Вместо этого войди в систему",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Инструмент № 1 для бухгалтерских практик. Автоматизированные рабочие процессы, учет рабочего времени, отчеты, мониторинг, CRM. Выполняй работу вовремя и с прибылью. Попробуй бесплатно!",
    "You are invited to join": "Приглашаем тебя присоединиться к",
    "Accept invitation": "Принять приглашение",
    "Check your email": "Проверьте свою электронную почту",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Я отправил тебе письмо со ссылкой для активации твоего аккаунта. Это важно для обеспечения безопасности твоего аккаунта.",
    "Go to": "Перейти",
    "Need a new password?": "Нужен новый пароль?",
    "Enter your e-mail address and we will send you directions for changing your password": "Введите адрес электронной почты, и мы вышлем вам инструкции по смене пароля",
    "Send me instructions": "Пришлите мне инструкции",
    "Never mind, go back": "Не бери в голову, возвращайся",
    "No login options enabled. Please contact the company owner": "Не включена опция входа в систему. Пожалуйста, свяжитесь с владельцем компании",
    "Log in to Uku": "Войдите в Uku",
    "Forgot password?": "Забыли пароль?",
    "Don't have account?": "Нет аккаунта?",
    "Create account": "Создать аккаунт",
    "Total items:": "Итого кол-во:",
    "Add new": "Добавить новый",
    "Amount": "Сумма",
    "Account created range": "Диапазон создания аккаунта",
    "Usage limit": "Лимит использования",
    "Valid until": "Действует до",
    "Edit help link": "Редактировать ссылку на помощь",
    "New help link": "Новая ссылка на помощь",
    "Name key": "Ключ имени",
    "Country code": "Код страны",
    "Period (months)": "Период (месяцы)",
    "Account created from": "Аккаунт создан от",
    "Account created until": "Аккаунт создан до",
    "Used count": "Используемый счетчик",
    "Sum": "Сумма",
    "Create voucher": "Создай ваучер",
    "Edit voucher": "Изменить купон",
    "Are you sure to delete this voucher?": "Ты уверен, что хочешь удалить этот ваучер?",
    "row | rows": "ряд | ряды",
    "Add event": "Добавить событие",
    "Are you sure you wish to delete this event?": "Ты уверен, что хочешь удалить это событие?",
    "event | events": "событие | события",
    "Security object id": "Идентификатор объекта безопасности",
    "Direct rights": "Прямые права",
    "Computed rights": "Вычисленные права",
    "Add link": "Добавить ссылку",
    "Are you sure you wish to delete this entry?": "Ты уверен, что хочешь удалить эту запись?",
    "link | links": "ссылка | ссылки",
    "Event type": "Тип события",
    "Date from": "Дата заезда",
    "Date until": "Дата до",
    "Shortened by h": "Сокращенно h",
    "Category": "Категория",
    "demo | demos": "демо | демо",
    "Companies": "Компании",
    "Leads": "Лиды",
    "Demos": "Демо",
    "Vouchers": "Ваучеры",
    "KPI": "KPI",
    "Activity log": "Счисление действий",
    "Notifications": "Уведомления",
    "Me": "Мне",
    "Important notifications will appear here.": "Здесь появляются важные уведомления для Вас.",
    "Back": "Назад",
    "Return to UKU": "Возвращение в UKU",
    "Choose plan for {0}": "Выбери план для {0}",
    "First payment will be made after the end of the trial period.": "Первая оплата будет произведена после окончания пробного периода.",
    "Members and subscription can always be changed.": "Участников и подписку всегда можно изменить.",
    "Your subscription is externally managed by Xero": "Your subscription is externally managed by Xero",
    "Select plan": "Select plan",
    "Billing period": "Расчетный период",
    "Compare features": "Сравни характеристики",
    "Cancel uku subscription": "Отменить подписку на uku",
    "{0} discount": "{0} скидка",
    "You have currently<br />{0} active member": "<br />{0}  активный/-ых пользователь/-ей",
    "You have currently<br />{0} active members": "Сейчас у тебя<br />{0} активных участников",
    "Select yearly plan": "Выберите годовой план",
    "Select monthly plan": "Выберите месячный план",
    "Attention!": "Внимание!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Если ты хочешь пользоваться Uku бесплатно, то деактивируй свой аккаунт и продолжай действовать по плану {0}",
    "per member/month (billed yearly)": "за одного участника в месяц (счет выставляется ежегодно)",
    "or {0} per member/month (monthly)": "или {0} за члена/месяц (ежемесячно)",
    "Everything in {0}, plus:": "Все, что было в {0}, плюс:",
    "Compare plans, feature-by-feature": "Сравни пакеты",
    "Deactivate account": "Деактивируй аккаунт",
    "Are you sure to deactivate {0} account?": "Ты уверен, что хочешь деактивировать {0} аккаунт?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Если ты решишь продолжить пользоваться планом фрилансера, твой аккаунт компании будет деактивирован. Данные, связанные с этой компанией, будут удалены.",
    "Deactivate": "Деактивировать",
    "Teamwork": "Работа в команде",
    "Unlimited clients + import": "Неограниченное количество клиентов + импорт",
    "Access management": "Управление доступом",
    "Custom fields": "Настраиваемые поля",
    "Live chat support": "Живая поддержка в чате",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Портал для клиентов",
    "New!": "Новый!",
    "Custom integrations": "Пользовательские интеграции",
    "Assisted clients import": "Помогал клиентам импортировать",
    "Tailor-made team workshop": "Индивидуальный командный семинар",
    "Early access to features": "Ранний доступ к функциям",
    "Pay by invoice": "Оплатить по счету",
    "Dedicated account manager": "Свой енеджер по работе с клиентами",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Привет! Твоя пробная версия закончилась. Чтобы продолжить работу, выбери план подписки {0}",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Привет! Чтобы воспользоваться этой функцией, тебе нужно обновить {0} план подписки",
    "Waiting for the subscription to complete": "Waiting for the subscription to complete",
    "Edit VAT number": "Edit VAT number",
    "VAT": "НДС",
    "This is subscription period amount.": "Это сумма за период подписки.",
    "You save yearly {0}": "Ты ежегодно экономишь {0}",
    "Add voucher": "Добавь ваучер",
    "Existing credit": "Существующий кредит",
    "Current payment": "Текущий платеж",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Это текущая сумма платежа. Твой банк также требует подтверждения суммы за период подписки.",
    "Confirm subscription {0}": "Подтверди подписку {0}",
    "Your subscription will renew on": "Твоя подписка будет продлена на",
    "Thank you for believing in us!": "Спасибо, что веришь в нас!",
    "Uku team": "Команда Uku",
    "Voucher {1} (-{0}%)": "Ваучер {1} (-{0}%)",
    "Voucher {0}": "Ваучер {0}",
    "New plan": "Новый план",
    "Changed plan": "Измененный план",
    "Add {0} member": "Добавить {0} пользователя",
    "Add {0} members": "Добавь {0} пользователя",
    "Remove {0} member": "Удалить {0} пользователя",
    "Remove {0} members": "Удалить {0} пользователей",
    "No changes to plan": "Никаких изменений в плане",
    "Discount -{0}% with Yearly subscription": "Скидка -{0}% при годовой подписке",
    "Yearly discounted price (-{0}%)": "Годовая цена со скидкой (-{0}%)",
    "Subscription updated": "Подписка обновлена",
    "Please wait": "Подождите",
    "Your payment failed": "Твой платеж не прошел",
    "Please check that you entered the data correctly or use another card": "Проверь данные карты или используй другую карту",
    "Try again": "Попробуйте еще раз",
    "Pay": "Оплатить",
    "Payment": "Оплата",
    "Payment method updated": "Обновленный способ оплаты",
    "Edit member": "Редактировать пользователя",
    "First name": "Имя",
    "Last name": "Фамилия",
    "External ID": "Внешний ID",
    "Select groups": "Выберите группы",
    "Administrator": "Администратор",
    "Invite sent": "Приглашение отправлено",
    "Activate member": "Активировать пользователя",
    "Deactivate member": "Деактивировать пользователя",
    "Invited": "Приглашенные",
    "Paid member": "Оплачиваемый пользователь",
    "Send an invitation": "Отправь приглашение",
    "Limited": "Ограниченно",
    "No invite, no access": "Нет приглашения - нет доступа",
    "Free until activated": "Бесплатно до активации",
    "No access, no charge": "Нет доступа - нет платы",
    "Hidden member": "Скрытый участник",
    "Edit members": "Изменить участников",
    "Select user": "Выбрать пользователя",
    "Member will be assigned to every selected client": "Пользователь будет назначен для каждого клиента",
    "Member will be removed from all selected clients": "Пользователь будет удален у всех выбранных клиентов",
    "Assign user": "Назначить пользователя",
    "Set as primary user": "Установить в качестве основного пользователя",
    "Added as a default user when adding a task plan": "Добавлен в качестве пользователя по умолчанию при добавлении плана задач",
    "Remove from new tasks": "Удалить из новых задач",
    "Remove from plan tasks": "Удалить из задач плана",
    "Remove": "Удалить",
    "Admin": "Администратор",
    "Remove user": "Удалить пользователя",
    "Assign to incomplete tasks": "Делегировать незавершенные задачи",
    "Reassign incomplete tasks": "Делегировать незавершенные задачи",
    "Assign to plan tasks": "Назначить выполнение плановых заданий",
    "Reassign plan tasks": "Перенаправить плановые задачи",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Владелец будет назначен на задачи, если удаленный пользователь был последним назначенным исполнителем",
    "Run integration": "Запустить интеграцию",
    "Run": "Запустить",
    "Integration configuration": "Конфигурация интеграции",
    "Read the manual": "Прочитай инструкцию",
    "Api key": "Api ключ",
    "Are you sure to delete this integration info?": "Ты уверен, что нужно удалять эту информацию об интеграции?",
    "Edit Contracts": "Редактировать контракты",
    "Replace following contracts": "Заменить следующие контракты",
    "Append services to following contracts": "Добавь услуги к следующим контрактам",
    "Choose template": "Выбрать шаблон",
    "Append only": "Только добавление",
    "with template": "с шаблоном",
    "All existing contracts": "Все существующие контракты",
    "All quarterly contracts": "Все квартальные контракты",
    "All monthly contracts": "Все месячные контракты",
    "All yearly contracts": "Все годовые контракты",
    "Next invoice number": "Следующий номер счета",
    "Number is too big, it cannot exceed 15 digits": "Число слишком большое, оно не может превышать 15 цифр",
    "Replace topic": "Заменить тему",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Все задания и планы с текущей темой будут заменены на новую выбранную тему.",
    "Topics replaced": "Темы заменены",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Все задания с темой `{0}` будут заменены на `{1}`. Операцию невозможно отменить, продолжить?",
    "Name of topic": "Название темы",
    "Change topic": "Изменить тему",
    "Add new topic": "Добавить новую тему",
    "This topic is in use. Do you wish to archive it?": "Эта тема уже используется. Не хочешь ли ты заархивировать ее?",
    "Are you sure that you want to delete this topic?": "Вы уверены в том, что хотите удалить данную тему?",
    "These items will be deleted permanently": "Эти предметы будут удалены навсегда",
    "Are you sure that you want to delete this client group?": "Ты уверен, что хочешь удалить эту клиентскую группу?",
    "This client group is in use. Do you wish to archive it?": "Эта клиентская группа уже используется. Не хочешь ли ты заархивировать ее?",
    "Edit client group": "Редактировать группу",
    "New client group": "Новая группа клиентов",
    "Price": "Цена",
    "Quantity": "Количество",
    "Unit will be translated to client language": "Блок будет переведен на язык клиента",
    "Pick date & time": "Выберите дату и время",
    "Share equally": "Делить поровну",
    "Change existing": "Измените существующие",
    "Choose bookmark": "Выберите закладку",
    "New title": "Новый заголовок",
    "Set as my default view": "Установить как мой вид по умолчанию",
    "Signature name": "Signature name",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Default signature": "Default signature",
    "Max. dimensions 130 x 130 px": "Max. dimensions 130 x 130 px",
    "Logo left": "Logo left",
    "Logo top": "Logo top",
    "No logo": "No logo",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "Email signature",
    "Edit email signature": "Edit email signature",
    "Add email signature": "Add email signature",
    "Font color": "Font color",
    "Actions": "Действия",
    "Delete signature": "Delete signature",
    "Do you wish to update related contracts and invoices?": "Хочешь ли ты обновить соответствующие контракты и счета?",
    "Update contract templates, active contracts and open invoices.": "Обновляй шаблоны договоров, активные контракты и открытые счета.",
    "The following fields will be updated": "Следующие поля будут обновлены",
    "Custom Value": "Пользовательское значение",
    "This product is in use. Do you wish to archive it?": "Этот продукт уже используется. Отправить в архив?",
    "Are you sure that you want to delete this product?": "Вы уверены в том, что хотите удалить этот продукт?",
    "Customize for client": "Настроить для клиента",
    "Customize for template": "Настроить под шаблон",
    "Open product template": "Открыть шаблон продукта",
    "Create product template": "Создай шаблон продукта",
    "Master template": "Мастер-шаблон",
    "Client product": "Клиентский продукт",
    "Client product / service": "Клиентский продукт / услуга",
    "New client product": "Новый клиентский продукт",
    "Template product": "Шаблонный продукт",
    "Template product / service": "Шаблонный продукт / услуга",
    "New template product": "Новый шаблонный продукт",
    "Edit translations": "Редактирование переводов",
    "Billable topics": "Оплачиваемые темы",
    "Billable time": "Оплачиваемое время",
    "Minimum quantity": "Минимальное количество",
    "Minimum time": "Минимальное время",
    "Integration parameters": "Параметры интеграции",
    "Empty values will use product default": "Пустые значения будут использовать продукт по умолчанию",
    "Pricing": "Ценообразование",
    "DC %": "Скид. %",
    "Sum all matching rows": "Просуммируй все совпадающие строки",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Когда эта функция включена, общая цена представляет собой кумулятивную сумму всех совпадающих рядов. По умолчанию общая цена использует только самый высокий совпадающий ряд.",
    "Prices since": "Цены действительны начиная с",
    "Add price": "Добавить цену",
    "Add pricing period": "Добавь период ценообразования",
    "Update contracts": "Обновить контракты",
    "(Without topic)": "(Без названия)",
    "Fixed price": "Постоянная цена",
    "Product": "Продукт",
    "Event created": "Созданно событие",
    "Project created": "Проект создан",
    "Event deleted": "Событие удалено",
    "Project deleted": "Проект удалён",
    "Workflow added": "Добавлен рабочий процесс",
    "Workflow removed": "Рабочий процесс удален",
    "Workflow updated": "Обновленный рабочий процесс",
    "Event cancelled": "Событие отменено",
    "Project cancelled": "Проект отменен",
    "Event reactivated": "Событие вновь активировано",
    "Project reactivated": "Проект восстановлен",
    "Event archived": "Событие заархивировано",
    "Project archived": "Проект заархивирован",
    "Event unarchived": "Событие неархивировано",
    "Project unarchived": "Проект неархивирован",
    "Event changed": "Событие изменилось",
    "Project changed": "Проект изменился",
    "Event status changed: {0}": "Статус события изменился: {0}",
    "Project status changed: {0}": "Статус проекта изменился: {0}",
    "Event status changed": "Статус события изменился",
    "Project status changed": "Статус проекта изменился",
    "Task created": "Задание создано",
    "Task changed": "Задание изменино",
    "Task finished": "Задание выполнено",
    "Task not finished": "Задание не выполнено",
    "Task deleted": "Задание удалено",
    "Add project": "Добавить проект",
    "Hide filters": "Скрыть фильтры",
    "Show filters": "Показать фильтры",
    "Cancel event": "Отмена события",
    "Cancel project": "Отмена проекта",
    "Manage event fields": "Управляй полями событий",
    "Manage project fields": "Управляй полями проекта",
    "New event": "Новое событие",
    "New project": "Новый проект",
    "{0} (Copy)": "{0} (копия)",
    "Are you sure you wish to delete this project?": "Ты уверен, что хочешь удалить этот проект?",
    "Are you sure to archive this event?": "Ты уверен, что сможешь заархивировать это событие?",
    "Are you sure to archive this project?": "Ты уверен, что нужно архивировать этот проект?",
    "Are you sure to cancel this event?": "Ты уверен, что отменишь это мероприятие?",
    "Are you sure to cancel this project?": "Ты уверен, что отменишь этот проект?",
    "Communication": "Связь",
    "Log": "Лог",
    "Create event workflow": "Создай рабочий процесс события",
    "Create project workflow": "Создай рабочий процесс проекта",
    "Use workflow templates to set up tasks effectively or": "Используй шаблоны рабочих процессов для эффективной постановки задач или",
    "Add tasks manually": "Добавляй задания вручную",
    "Save bookmark": "Сохранить закладку",
    "Remove filters": "Чтобы расширить область поиска, измените или удалите фильтры выше",
    "Filter": "Фильтр",
    "Show multiselect": "Покажи мультиселект",
    "To do today": "Сделать сегодня",
    "This and next month": "В этом и следующем месяце",
    "Last 3 months": "Последние 3 месяца",
    "Next 3 months": "Следующие 3 месяца",
    "Starts": "Начало",
    "To do": "Сделать",
    "today": "сегодня",
    "tomorrow": "завтра",
    "yesterday": "вчера",
    "Previous week": "На прошлой неделе",
    "Group similar tasks": "Сгруппировать похожие задания",
    "Group by client": "Сгруппировать по клиентам",
    "Group by date": "Сгруппировать по дате",
    "Group by topic": "Сгруппировать по темам",
    "Your details": "Ваши данные",
    "City": "Город",
    "Regional format": "Региональный формат",
    "Default company": "Компания по умолчанию",
    "Lock time entries notification": "Уведомление о времени блокировки записей",
    "Notify by": "Сообщи об этом",
    "Delete my account": "Удалить мой аккаунт",
    "Attention": "Внимание",
    "Are you sure that you want to delete your account?": "Вы уверены в том, что хотите удалить свой аккаунт?",
    "Notification": "Уведомление",
    "Notification & email": "Уведомление и электронная почта",
    "Vacations / absence": "Отпуск / отсутствие",
    "Edit balance": "Редактировать баланс",
    "View history": "Посмотреть историю",
    "Request": "Запрос",
    "How long": "Как долго",
    "Requested": "Запрошено",
    "Approved": "Одобрено",
    "Rejected": "Отклонено",
    "In review": "В обзоре",
    "Change": "Изменить",
    "Agreements": "Соглашения",
    "New agreement": "Новое соглашение",
    "Change agreement": "Соглашение об изменении",
    "Stop demo": "Остановить демо",
    "Show": "Показать",
    "Don't show": "Не показывать",
    "Don't send": "Не отправлять",
    "Email workdays at 7 AM": "На электронную почту по рабочим дням в 7:00",
    "Email at 3 PM": "На электронную почту в 15:00",
    "Email at once": "Сразу на электронную почту",
    "Email Sundays at 11 PM": "На электронную почту в воскресенье в 23:00",
    "First day of the month": "Ежемесячно в первый день месяца",
    "to email": "на электронную почту",
    "E-mail at once": "На электронную почту сразу",
    "System": "Система",
    "Person": "Человек",
    "Picture": "Фото",
    "Time zone": "Часовой пояс",
    "Calendar settings": "Настройки календаря",
    "Public holidays": "Государственные праздники",
    "Tax deadlines": "Налоговые сроки",
    "News": "Новости",
    "External services": "Услуги извне",
    "Google log in": "Войти через Google",
    "Microsoft log in": "Вход в систему Microsoft",
    "Are you sure to remove microsoft?": "Ты уверен, что удаляешь microsoft?",
    "Agreement": "Договор",
    "Active agreement": "Активное соглашение",
    "Weekly hours": "Недельные часы",
    "Are you sure to remove google?": "Ты уверен, что удалишь \"Гугл\"?",
    "Edit supplier": "Поставщик правки",
    "New supplier": "Новый поставщик",
    "Are you sure you wish to delete this supplier?": "Ты уверен, что хочешь удалить этого поставщика?",
    "Add supplier": "Добавить поставщика",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Типы поставщиков не определены. Перейдите в настройки приложения \"Поставщики\", чтобы добавить их.",
    "No members yet": "Пока нет участников",
    "Edit group": "Изменить группу",
    "Add group": "Добавить группу",
    "Are you sure to delete this user group?": "Ты уверен, что хочешь удалить эту группу пользователей?",
    "Get set up to work with team": "Настройся на работу с командой",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Корпоративный аккаунт позволяет использовать инструменты для команд, получать более глубокую аналитику и многое другое. Повышайте качество работы вашей команды и ведите более прибыльный бизнес.",
    "Create company account": "Создание учетной записи компании",
    "By creating a company account you activate Uku free subscription for {0} days.": "Создав аккаунт компании, ты активируешь бесплатную подписку Uku на {0} дней.",
    "You have invited {0}/{1} members": "У компании {0}/{1} пользователей",
    "Upgrade": "Обновить",
    "Resend invite": "Пригласить снова",
    "Send invite": "Отправить приглашение",
    "View profile": "Просмотреть профиль",
    "To add members to your team, you'll need to create a company account": "Чтобы добавить пользователей в свою команду, тебе нужно будет создать аккаунт компании",
    "Export": "Экспорт",
    "Re-invite sent": "Повторное приглашение отправлено",
    "View report": "Посмотреть отчет",
    "Member {0} will be deactivated.": "Пользователь {0} будет деактивирован.",
    "Please select new member who will replace {0}.": "Пожалуйста, выберите нового пользователя, который заменит {0}.",
    "Select new member": "Выберите нового пользователя",
    "NB! Deactivation process cannot be reversed": "NB! Процесс деактивации нельзя отменить",
    "Magic button settings": "Настройки умной кнопки",
    "Create only one task per month": "Создавай только одно задание в месяц",
    "Current month's tasks": "Задачи на текущий месяц",
    "extra work": "дополнительная работа",
    "Without topic": "Без темы",
    "Week": "Неделя",
    "Previous month": "Предыдущий месяц",
    "task | tasks": "задание | задачи",
    "Assign to": "Назначить на",
    "Mark as done": "Отметить как завершенное",
    "Last": "Последний",
    "Snooze": "Отложить",
    "1 dependency": "1 зависимость",
    "{0} dependencies": "{0} зависимости",
    "Client request": "Запрос клиента",
    "Unread notification emails": "Unread notification emails",
    "Unread internal comments": "Unread internal comments",
    "Add comment": "Добавить комментарий",
    "Internal comment": "Внутренний комментарий",
    "Portal message": "Сообщение портала",
    "Public message means that clients can read it and the client portal will notify them by email": "Публичное сообщение означает, что клиенты могут его прочитать, а клиентский портал уведомит их об этом по электронной почте",
    "Type a comment": "Введите комментарий",
    "Send portal message": "Отправить сообщение на портал",
    "Open timesheet": "Открытый табель учета рабочего времени",
    "Pause timer": "Таймер паузы",
    "Mark undone": "Отметить как незавершенное",
    "Digitise": "Оцифруй",
    "Documents sent to digitisation": "Документы, отправленные на оцифровку",
    "Followers": "Подписчики",
    "Start / Due date": "Дата начала / дата окончания",
    "Select topic": "Выберите тему",
    "1 document": "1 документ",
    "{0} documents": "{0} документы",
    "Download": "Скачать",
    "Download all": "Скачать все",
    "Assign as task": "Назначить в качестве задания",
    "When selected, the task is sent as a task to the client": "При выборе задания оно отправляется клиенту в виде задачи",
    "Auto finish": "Автоматическое завершение",
    "When selected, the task is marked done after client finishes it": "При выборе этого пункта задание помечается выполненным после того, как клиент его завершит",
    "Add comment / message": "Добавить комментарий / сообщение",
    "Add email": "Добавить адрес электронной почты",
    "Add estimation": "Добавить оценку",
    "Add task field": "Добавь поле для задания",
    "Add dependency": "Добавить зависимость",
    "Drop files to upload": "Перемести файлов для загрузки",
    "Task sent to client portal": "Задание отправлено на клиентский портал",
    "Task no longer assigned to client portal": "Задание больше не отправлено на клиентском портале",
    "Save recurring task": "Сохранить повторяющееся задание",
    "Add to-do list": "Добавь список дел",
    "Waiting for event status: {0}": "Ожидание статуса события: {0}",
    "Waiting for project status: {0}": "Ожидание статуса проекта: {0}",
    "Edit template task": "Задание по редактированию шаблона",
    "Create recurring task": "Создайте повторяющееся задание",
    "Make a copy": "Создать копию",
    "Add topic": "Добавить тему",
    "Delete task": "Удалить задачу",
    "Delete task template": "Удалить шаблон задания",
    "Select task field": "Выберите поле для задания",
    "No custom fields available for this client": "Для этого клиента недоступны пользовательские поля",
    "task": "задача",
    "recurring task": "повторяющееся задание",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Собираешься ли ты удалить себя из {0} или хочешь удалить его полностью?",
    "This {1} is shared with {0}": "Этот {1} делится с {0}",
    "Remove only me": "Удалите только меня",
    "Time has been tracked to this task.": "Время было зафиксировано для этой задачи.",
    "Are you sure to delete this task?": "Ты уверен, что хочешь удалить это задание?",
    "Undefined": "Не определено",
    "COPY": "КОПИРОВАТЬ",
    "On task due date": "Срок выполнения задания",
    "{0} day before": "{0} за день до",
    "{0} days before": "{0} дней до",
    "Edit workflow": "Редактирование рабочего процесса",
    "Duplicate project": "Дублировать проект",
    "Reset layout": "Сбросить раскладку",
    "Any time": "В любой момент",
    "Assign user...": "Назначьте пользователя...",
    "1 min": "1 мин",
    "5 min": "5 мин",
    "10 min": "10 мин",
    "30 min": "30 мин",
    "1 h": "1 час",
    "Add notes": "Добавь заметки",
    "Task start date": "Дата начала выполнения задания",
    "Task due date": "Срок выполнения задания",
    "Recurrence task": "Повторная задача",
    "Search from one time templates": "Поиск по одноразовым шаблонам",
    "Placeholders": "Placeholders",
    "New task": "Новая задача",
    "New recurring task": "Новая повторяющаяся задача",
    "+1 day": "+1 день",
    "Edit comment": "Редактировать комментарий",
    "Timer is running!": "Таймер запущен!",
    "Continue time from {0}": "Продолжить время с {0}",
    "New time entry": "Новый ввод времени",
    "Load more": "Загрузить больше",
    "Are you sure to delete this time entry?": "Ты уверен, что хочешь удалить эту временную запись?",
    "Save automated email": "Сохрани автоматическое письмо",
    "Automation": "Автоматизация",
    "Are you sure to delete this email?": "Ты уверен, что хочешь удалить это письмо?",
    "Are you sure you wish to send this email immediately?": "Ты уверен, что хочешь отправить это письмо немедленно?",
    "replied to project email": "replied to project email",
    "replied to client email": "replied to client email",
    "commented": "добавил комментарий",
    "Reply": "Ответить",
    "Are you sure to delete this comment?": "Ты уверен, что удалишь этот комментарий?",
    "replied to client portal email": "ответил/-а клиенту через Портал",
    "sent a message": "отправил сообщение",
    "replied to task email": "replied to task email",
    "failed to send": "не удалось отправить",
    "sent email": "отправил письмо",
    "no one": "никто",
    "created this task.": "создал это задание.",
    "Task was automatically created from forwarded e-mail": "Задание было создано автоматически на основании перенаправленного e-mail",
    "Task was automatically created from client portal e-mail": "Task was automatically created from client portal e-mail",
    "Task was automatically created from client e-mail": "Task was automatically created from client e-mail",
    "Task was automatically created from project e-mail": "Task was automatically created from project e-mail",
    "requested assistance.": "попросил о помощи.",
    "updated this task.": "обновил это задание.",
    "tracked time to this task.": "отследил время на выполнение этого задания.",
    "finished this task.": "завершил это задание.",
    "new comment.": "новый комментарий.",
    "reassigned this task.": "перепоручил это задание.",
    "assigned the task to {0}.": "назначил задание на {0}.",
    "reminder.": "напоминание.",
    "deleted.": "удалено.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "выполнил задание, но Uku не автозавершил это задание, потому что не все требования задания были выполнены.",
    "sent task to client portal": "отправил задание на клиентский портал",
    "assigned the task to client.": "поручил задание клиенту.",
    "assigned the task to company.": "поручил задание компании.",
    "added attachment(s).": "добавлено приложение(и).",
    "added a comment.": "добавил комментарий.",
    "added a message to {0}.": "добавил сообщение в {0}.",
    "received a e-mail from {0}.": "received a e-mail from {0}.",
    "updated notes.": "обновленные заметки.",
    "made changes to checklist.": "внес изменения в чеклист.",
    "created this task template.": "создал этот шаблон задания.",
    "updated this task template.": "обновил этот шаблон задания.",
    "recurring task assigned.": "повторяющаяся задача поставлена.",
    "recurring task deleted.": "повторяющееся задание удалено.",
    "added email.": "добавлена электронная почта.",
    "changed email.": "изменил электронную почту.",
    "deleted email.": "удалённое письмо.",
    "sent email.": "отправил электронное письмо.",
    "failed to send.": "не удалось отправить.",
    "added email": "добавил электронную почту",
    "changed email": "изменил электронную почту",
    "deleted email": "удалённое письмо",
    "Member / Time": "Пользователь / Время",
    "Client/topic": "Клиент/тема",
    "Client/task": "Клиент/задача",
    "Client/member": "Клиент/член",
    "Member/topic": "Пользователь/тема",
    "Member/task": "Пользователь/задание",
    "Member/client": "Пользоваель/клиент",
    "Member/date": "Пользователь/дата",
    "Date/member": "Дата/пользователь",
    "Grouped": "Сгруппирован",
    "Client/project": "Клиент/проект",
    "Project/member": "Проект/пользователь",
    "Period balance": "Баланс периода",
    "Reset balance": "Сбросьте баланс",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Ввод времени был подтвержден или продолжительность была изменена, и продолжительность не будет динамически обновляться",
    "(Without project)": "(Без проекта)",
    "Decline": "Отклонить",
    "Accept": "Принять",
    "Cancel decision": "Отменить решение",
    "Accepted": "Принято",
    "Declined": "Отклонено",
    "Report data has changed. Please update report.": "Данные отчета изменились. Пожалуйста, обновите отчет.",
    "Agreed": "Согласен",
    "Non billable": "Не оплачиваемый",
    "Export report to Excel": "Экспортируй отчет в Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "По умолчанию мы экспортируем результат выбранных фильтров с колонками настроенной таблицы",
    "Add to export client custom fields": "Добавь в экспорт пользовательские поля клиента",
    "Save report": "Сохранить отчет",
    "Export PDF": "Экспорт в PDF",
    "Export Excel": "Экспорт Excel",
    "We have new version of": "Новая версия",
    "Log out": "Выйти",
    "Previous day": "Предыдущий день",
    "Next day": "Следующий день",
    "Mark all as read": "Отметить все как прочитанное",
    "Search task/client": "Поисковое задание/клиент",
    "from client portal": "с клиентского портала",
    "Hide all": "Скрыть",
    "Hide for 1 hour": "Скрыть на 1 час",
    "Something went wrong": "Что-то пошло не так",
    "User authentication needed": "Необходима аутентификация пользователя",
    "Invalid rights": "Недействительные права",
    "The object cannot be found": "Объект не найден",
    "Content too large": "Слишком большой контент",
    "An unknown error occurred": "Произошла неизвестная ошибка",
    "The action requested cannot be performed": "Запрошенное действие не может быть выполнено",
    "Go": "Перейти",
    "Actual / monitoring (month)": "Факт/контроль (месяц)",
    "h": "ч",
    "Actual": "Фактически",
    "Month": "Месяц",
    "I’m setting up your account": "Настраиваем аккаунт",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Знали ли вы, что бухгалтерские фирмы, начавшие использовать Uku, могут обслуживать на 38% больше клиентов за то же время?",
    "Let’s setup your company": "Создать свою компанию",
    "Name of your company": "Название твоей компании",
    "Size of your team?": "Количество пользователей?",
    "Which software are you using?": "Какую программу ты используешь?",
    "This knowledge will help us to improve Uku": "Эти знания помогут нам улучшить Uku",
    "What other software needs to be integrated?": "Какие еще программы нужно интегрировать?",
    "Book a demo": "Забронируй демо-версию",
    "Hi {0},": "Привет {0},",
    "NO BOTS - ONLY HUMANS": "НИКАКИХ БОТОВ - ТОЛЬКО ЛЮДИ",
    "Start a 14 day free trial": "Начни 14-дневную бесплатную пробную версию",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "\"Uku - невероятно функциональное программное обеспечение. Uku повысил эффективность управления нашей работой и помогает нам предоставлять исключительный сервис\"",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Самый быстрый способ решить, поможет ли Uku твоей компании {0}, - это {1} минутный звонок нашему специалисту по работе с клиентами.",
    "Hi, I'm Uku ": "Добро пожаловать!",
    "I help to set up your account.": "Поможем настроить твой аккаунт.",
    "It only takes a minute.": "Это займет всего минуту.",
    "Choose": "Выбрать",
    "Your country": "Ваша страна",
    "Your language": "Твой язык",
    "Begin": "Начало",
    "Let’s become friends": "Давай станем друзьями",
    "Your first name": "Ваше имя",
    "What is your field of work?": "В какой сфере ты работаешь?",
    "Your field of work": "Твоя сфера деятельности",
    "How will you use Uku?": "Как ты будешь использовать Uku?",
    "How did you hear about Uku?": "Как ты узнал об Уку?",
    "Choose channel": "Выберите канал",
    "Please specify how you heard about us": "Пожалуйста, укажи, как ты узнал о нас",
    "Let me know Uku's new features by email": "Сообщи мне о новых возможностях Uku по электронной почте",
    "Finish": "Завершить",
    "First name is required": "Имя обязательно",
    "Name is required": "Имя обязательно",
    "Team size is required": "Укажите количество пользователей",
    "Surname is required": "Фамилия обязательна",
    "Field is required": "Обязательное поле",
    "I will use Uku to work together with two or more teammates.": "Я буду использовать Uku, чтобы работать вместе с двумя или более товарищами по команде.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Я буду использовать Uku в одиночку. Этот план бесплатный, но возможности ограничены.",
    "Media": "Медиа",
    "Through integration partner": "Через партнера по интеграции",
    "Referral by friend": "Направление от друга",
    "Import speeds up your clients setup, smart choice!": "Импорт ускоряет настройку твоих клиентов, умный выбор!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Последний импорт: добавлен {0}, обновлен {1}, пропущен {2}, не удалось импортировать {3} клиента",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Последний импорт: добавлено {0}, обновлено {1}, пропущено {2}, не удалось импортировать {3} клиентов",
    "Last import: added {0}, updated {1}, skipped {2}": "Последний импорт: добавлен {0}, обновлен {1}, пропущен {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Что делать дальше? Исправь данные клиентов {0} и загрузи снова.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX)",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Вместо того чтобы вводить клиентов по одному, ты можешь использовать импорт файлов для большой клиентской базы.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Импортируй всех клиентов Merit Aktiva и автоматически обновляй данные о них",
    "Ignore": "Игнорировать",
    "NEW CLIENT": "НОВЫЙ КЛИЕНТ",
    "Preview": "Предпросмотр",
    "Import started": "Импорт запущен",
    "Only new clients": "Только новые клиенты",
    "Update data from company register": "Обновление данных из реестра компаний",
    "If switched on, the company data is updated using the local business register": "Если включено, то данные о компании обновляются с помощью местного реестра предприятий",
    "We did not find a match in Äriregister": "Мы не нашли совпадений в Äriregister",
    "We did not find a match in Companies House": "Мы не нашли подходящего варианта в Companies House",
    "No integration yet": "Интеграции пока нет",
    "Uku match": "Совпадение с Uku",
    "Business register nr.": "Регистрационный номер предприятия.",
    "Company register": "Реестр компаний",
    "Upload file": "Загрузить файл",
    "Before uploading your file": "Перед тем как загрузить свой файл",
    "Learn Uku’s data structure": "Изучи структуру данных Uku",
    "Download and use our sample file to see exactly how we organize data in Uku": "Скачай и используй образец файла, чтобы увидеть, как организованна база данных в Uku",
    "Download Client Import Example": "Скачать образец файла импорта клиентов",
    "Download Contact Import Example": "Скачать образец файла импорта контактов клиентов",
    "Fill in fields": "Заполни поля",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Единственное обязательное поле - название компании. Убедись, что ты заполнил все необходимые поля, прежде чем загружать файл.",
    "Learn more about mandatory fields": "Узнай больше об обязательных полях",
    "Create custom fields": "Создай пользовательские поля",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Некоторые поля данных могут отсутствовать по умолчанию. Убедись, что ты создал эти пользовательские поля перед импортом данных.",
    "Add new custom fields": "Добавь новые пользовательские поля",
    "...or drag a file here": "...или перенеси файл сюда",
    "Only Excel (.xls, .xlsx) file types are supported": "Поддерживаются только типы файлов Excel (.xls, .xlsx)",
    "Mapping": "Отображение",
    "First row is a header": "Первый ряд - это заголовок",
    "Add field to all clients": "Добавь поле всем клиентам",
    "Add client group": "Добавь группу клиентов",
    "Fields for all clients": "Поля для всех клиентов",
    "Import of {0} in progress": "Импорт {0} в процессе",
    "Import in progress": "Импорт выполняется",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Это может занять некоторое время. В это же время ты можешь заниматься другими делами в Уку, мы сообщим тебе, когда все будет готово.",
    "Cancel import": "Отменить импорт",
    "Are you sure you want to cancel import?": "Ты уверен, что хочешь отменить импорт?",
    "Last updated": "Последнее обновление",
    "Contracts": "Контракты",
    "Job name": "Название задачи",
    "Workflow name": "Рабочий процесс",
    "Details": "Детали",
    "Select jobs": "Выберите задания",
    "Select task plan": "Выберите план заданий",
    "of existing client": "существующего клиента",
    "You can also choose": "Ты также можешь выбрать",
    "existing client tasks plan": "план выполнения заданий для существующих клиентов",
    "existing predefined jobs": "существующие шаблоны заданий",
    "create a new plan": "создай новый план",
    "Select workflow": "Выберите рабочий процесс",
    "existing project workflow": "существующий рабочий процесс проекта",
    "existing workflow": "существующий рабочий процесс",
    "create a new workflow": "создай новый рабочий процесс",
    "New tasks template": "Шаблон новых заданий",
    "to save template!": "чтобы сохранить шаблон!",
    "You can also add tasks from jobs": "Ты также можешь добавлять задачи из заданий",
    "or choose": "или выбрать",
    "New workflow template": "Новый шаблон рабочего процесса",
    "You can also add tasks from existing workflow templates": "Ты также можешь добавлять задачи из существующих шаблонов рабочих процессов",
    "existing event workflow": "существующий рабочий процесс",
    "Hide others": "Скрыть другие",
    "Update all events (New tasks)": "Обнови все события (Новые задания)",
    "Update all projects (New tasks)": "Обнови все проекты (новые задачи)",
    "Once": "Один раз",
    "Once a month": "Один раз в месяц",
    "Once a quarter": "Один раз в квартал",
    "Once a year": "Один раз в год",
    "Company workflow": "Рабочий процесс компании",
    "Company jobs": "Задачи компании",
    "Default jobs": "Задания по умолчанию",
    "ID": "ID",
    "Task title and labels": "Название задачи и ярлыки",
    "Assigned and time": "Назначение и время",
    "Setup tasks for {0} event": "Установочные задания для события {0}",
    "Setup tasks for {0} project": "Установка задач для проекта {0}",
    "New job": "Новое задание",
    "Edit job": "Редактировать задание",
    "New workflow": "Новый рабочий процесс",
    "Save workflow": "Сохранить рабочий процесс",
    "Create task plan": "Создай план выполнения заданий",
    "Confirm task plan": "Подтверди план выполнения заданий",
    "Skip": "Пропустить",
    "Confirm workflow": "Подтверди рабочий процесс",
    "Client portal templates": "Шаблоны портала Клиентов",
    "Jobs": "Список заданий",
    "Workflows": "Процессы",
    "Company workflows": "Процессы компании",
    "Default workflows": "Рабочие процессы по умолчанию",
    "Company template saved": "Шаблон компании сохранен",
    "Company template created": "Создан шаблон компании",
    "Format": "Формат",
    "Currency": "Валюта",
    "Reference number": "Номер ссылки",
    "Invoice description": "Описание счета",
    "Summarize invoice rows": "Суммируй строки счета-фактуры",
    "Summarized description": "Обобщенное описание",
    "Reverse charge": "Обратная оплата налога",
    "Rounding": "Округление",
    "Time rounding will apply for each line": "Для каждого ряда будет применяться округление времени",
    "Rounding increment (up)": "Округление (в большую сторону)",
    "Reply to": "Ответить",
    "Configuration": "Конфигурация",
    "Invoice to parent company": "Выставить счет материнской компании",
    "Create all invoices under parent company.": "Создать все счета под материнскую компанию.",
    "User code": "Код пользователя",
    "Default": "По умолчанию",
    "Default value will apply for each line": "Значение по умолчанию будет применяться для каждого ряда",
    "Number": "Номер",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "В поле invoice prefix ты можешь записать любое из следующих значений в фигурных скобках. При сохранении контракта префикс будет заполнен соответствующим значением.",
    "Copy to clipboard": "Копировать в буфер",
    "Invoice previous period": "Счет за предыдущий период",
    "Invoice period": "Период выставления счета",
    "Invoice next period": "Счет за следующий период",
    "Client primary user": "Основной пользователь клиента",
    "Original client name": "Оригинальное имя клиента",
    "invoice date year": "год даты выставления счета",
    "last two digits of invoice date year": "последние две цифры даты выставления счета год",
    "invoice date month": "дата выставления счета месяц",
    "invoice date day": "дата выставления счета день",
    "Copied to clipboard": "Скопировано в буфер обмена",
    "Contract": "Договор",
    "Net total": "Итого нетто:",
    "Contract #": "Договор №",
    "Invoice #": "Счет #",
    "Exported": "Экспортировано",
    "Sent": "Отправлено",
    "Net": "Сальдо",
    "Add invoice": "Добавить счет",
    "Change invoice number": "Изменить номер счета",
    "Review changes": "Просмотрите изменения",
    "Please review and approve changes to the related events": "Пожалуйста, просмотрите и одобрите изменения в связанных событиях",
    "Please review and approve changes to the related projects": "Пожалуйста, просмотри и одобри изменения в связанных проектах",
    "Contains": "Содержит",
    "contains": "содержит",
    "Exactly": "Точно",
    "is exactly": "точно",
    "Greater than": "Больше чем",
    "is greater than": "больше, чем",
    "Less than": "Меньше, чем",
    "is less than": "меньше, чем",
    "Range": "Диапазон",
    "is in range of": "находится в диапазоне",
    "is empty": "пустое",
    "Task plan": "План задач",
    "Edit plan": "Изменить план",
    "Use task plan templates to set up tasks effectively or add a task manually": "Используй шаблоны планов задач, чтобы эффективно их настроить, или добавь задачу вручную",
    "Add task manually": "Добавь задание вручную",
    "Quarterly": "Ежеквартально",
    "Export excel": "Экспорт excel",
    "Print PDF": "Распечатать PDF",
    "Edit jobs": "Отредактируй задания",
    "Replace plan tasks with job": "Замените плановые задания на работу",
    "Select template": "Выберите шаблон",
    "member": "участник",
    "Tasks with user will be added to every selected client": "Задания с пользователем будут добавляться к каждому выбранному клиенту",
    "Add even if job already applied": "Добавляй, даже если задание уже подано",
    "Default user": "Пользователь по умолчанию",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Это удалит все задачи из клиентского плана и поместит в него только задачи выбранного шаблона",
    "Adding template will be ready in a minute. You can continue with work.": "Добавление шаблона будет готово через минуту. Вы можете продолжить работу.",
    "Add client": "Добавить клинета",
    "Export clients": "Выгрузка клиентов",
    "Export client contacts": "Экспортируй контакты клиентов",
    "client | clients": "клиент | клиент",
    "clients": "клиенты",
    "client(s) had errors": "у клиента(ов) были ошибки",
    "client(s) selected": "выбранный клиент(ы)",
    "Contract actions": "Действия по контракту",
    "Edit Members": "Редактировать членов",
    "Edit monitoring": "Редактирование мониторинга",
    "Your company": "Ваша компания",
    "Edit billing": "Редактирование счетов",
    "Activate client portal": "Активируй клиентский портал",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "После активации ты сможешь отправлять задания напрямую всем контактам клиента, у которых есть адрес электронной почты.",
    "Send welcome invitation to client contacts": "Отправь приветственное приглашение контактам клиента",
    "Who will receive an invitation?": "Кто получит приглашение?",
    "Client contact who has one valid e-mail address": "Контакт с клиентом, у которого есть один действующий адрес электронной почты",
    "Client contact who has the client's portal open (default for all)": "Контакт с клиентом, у которого открыт портал клиента (по умолчанию для всех)",
    "How does the invitation work?": "Как работает приглашение?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku создает и отправляет каждому клиенту задание \"Добро пожаловать\". Она создается основным пользователем клиента на основе шаблона задачи \"Добро пожаловать на портал клиента\". Посмотри его в разделе \"Шаблоны задач твоей компании\". Она будет переведена в соответствии с языком контакта.",
    "Uku client portal always informs clients by email about new tasks.": "Клиентский портал Uku всегда информирует клиентов по электронной почте о новых заданиях.",
    "View templates": "Посмотреть шаблоны",
    "Client portal activated": "Активирован клиентский портал",
    "Company's name": "Название фирмы",
    "Mark": "Знак",
    "Add members": "Добавить участников",
    "Members and groups": "Члены и группы",
    "Topic is required": "Тема обязательна",
    "Entering time is required": "Необходимо ввести время",
    "Delete client": "Удалить клиента",
    "Manage client fields": "Управляй полями клиентов",
    "Max 3 characters": "Не более 3 символов",
    "Are you sure you wish to delete this client?": "Ты уверен, что хочешь удалить этого клиента?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "При удалении данных клиента будут удалены и все связанные с ним задания.<br/><br/>NB! История клиента будет удалена",
    "Owner": "Владелец",
    "All clients that you add under {0} will be deleted later.</div>": "Все клиенты, которых ты добавишь в раздел {0}, будут удалены позже.</div>",
    "Use this account for testing purposes only!": "Используй этот аккаунт только для тестирования!",
    "Read more about the demo account": "Подробнее о демо-счете",
    "Rights": "Права",
    "Monitoring setup": "Настройка мониторинга",
    "Learn more about monitoring": "Узнай больше о мониторинге",
    "selected": "выбрано",
    "Invoicing": "Выставление счетов",
    "Billing template": "Шаблон для выставления счетов",
    "New": "Новый",
    "Add row": "Добавить ряд",
    "Delete contract": "Удалить контракт",
    "Product / description": "Продукт / описание",
    "Qty": "Количество",
    "Product placeholders": "Месторасположение продуктов",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "Вы можете вставить любую из следующих строк в фигурных скобках в описание продукта. При сохранении счета текст будет заменен на соответствующее значение.",
    "Template saved": "Шаблон сохранен",
    "Warning": "Предупреждение",
    "Would you like to apply these changes to all clients using this contract template?": "Хочешь применить эти изменения ко всем клиентам, использующим этот шаблон контракта?",
    "Yes, apply to all clients": "Да, применяется ко всем клиентам",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Вы изменили временной период, связанный с этим договором. Это может повлиять на выствление счетов за еще неучтенные услуги. Подтвердите, пожалуйста, то, что желаете внести это изменение.",
    "Are you sure to delete this template?": "Вы уверены, что хотите удалить этот шаблон?",
    "Save template": "Сохранить шаблон",
    "Save as template": "Сохранить как шаблон",
    "Please note all changes made to contract will be lost": "Обратите внимание, что все изменения, внесенные в контракт, будут потеряны",
    "Add contract": "Добавить контракт",
    "Manage contract templates": "Управляй шаблонами договоров",
    "Change account details": "Изменить данные аккаунта",
    "Country is required": "Страна обязательна",
    "Address": "Адрес",
    "Postal code": "Почтовый индекс",
    "State": "Область",
    "Uku is set up according to the field of work.": "Уку настраивается в зависимости от сферы деятельности.",
    "Size of the team": "Размер команды",
    "Website": "Website",
    "Delete account": "Удалить аккаунт",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Удалив аккаунт, ты также удалишь всех клиентов, связанных с ним, их задания и всю их историю. Ты уверен, что хочешь удалить свой аккаунт?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Да, удалить аккаунт со всеми связанными с ним данными: клиентами, задачами и историей",
    "These invoices cannot be sent. Check their status or error messages.": "Эти счета не могут быть отправлены. Проверь их статус или сообщения об ошибках.",
    "Please confirm that you wish to proceed.": "Пожалуйста, подтверди, что ты хочешь продолжить.",
    "Sending invoice | Sending invoices": "Отправка счетов | Отправка счетов",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Ты собираешься отправить этот счет клиенту по электронной почте. | Ты собираешься отправить эти счета клиентам по электронной почте.",
    "Error in calculating invoice": "Ошибка при расчете счета",
    "Error in importing invoice": "Ошибка при импорте счета",
    "Error in creating invoice": "Возникла ошибка при составлении счета",
    "Error in exporting invoice": "Возникла ошибка во время экспорта счета",
    "Error in sending invoice": "Возникла ошибка при отправке счета",
    "Calculating invoice": "Расчет счета",
    "Creating invoice": "Создаю счет",
    "Exporting invoice": "Экспорт счета",
    "Importing invoice": "Импортирование счета",
    "Sending invoice": "Отправка счета",
    "Clear errors": "Удалить ошибки",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Связанные задачи будут снова занесены в расчет. Счета не удаляются автоматически из внешних систем, это следует сделать вручную.",
    "Delete invoice | Deleting invoices": "Удалить счет | Удаление счетов",
    "Selected net total": "Выбранная чистая сумма",
    "Nothing in invoices": "Пустые счета",
    "Please make sure you have setup recurring billing for your clients": "Убедитесь в том, что вы установили повторный расчет для своих клиентов",
    "Draft": "Черновик",
    "Approval": "Одобрение",
    "Created": "Создано",
    "Coming soon": "Скоро",
    "Selected invoices and related product info will be sent to accounting system.": "Выбранные счета вместе с продуктами будут отправлены в бухгалтерскую систему.",
    "Piece": "Штука",
    "Hour": "Час",
    "Delete row": "Удалить строку",
    "Out of ": "Из ",
    " can be created": " может быть создано",
    "For ": "Для ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " расчетный период еще идет. После составления счета в течение данного периода новые задачи не учитываются.",
    "Invoice date will be set to today.": "Дата выставления счета будет установлена на сегодня.",
    "Uku is about to create": "В процессе создания Уку",
    " selected row, only | selected row, only ": " выбранный ряд, только | выбранный ряд, только",
    " invoice | invoices": " счет | счета",
    "These invoices cannot be exported. Check their status or error messages.": "Эти счета не могут быть экспортированы. Проверь их статус или сообщения об ошибках.",
    "Exporting invoice | Exporting invoices": "Экспорт счетов | Экспорт счетов",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Ты собираешься экспортировать этот счет в бухгалтерию. | Ты собираешься экспортировать эти счета в бухгалтерию.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "Этот счет уже был экспортирован. Вы уверены, что хотите экспортировать его как новый счет?",
    "Download pdf": "Скачать pdf",
    "Create invoice": "Создать счет",
    "Update status from {0}": "Обнови статус с {0}",
    "Show all lines": "Показать все ряды",
    "Calculate invoice": "Рассчитать счет",
    "Loading invoice...": "Загрузка счета...",
    "Invalid Scoro credentials": "Недействительные учетные данные Scoro",
    "Please confirm the changes you have made to this invoice.": "Подтвердите, пожалуйста, то, что Вы желаете сохранить сделанные в счете изменения.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Измененный счет не отправляется клиенту и не экспортируется третьим лицам автоматически, это следует сделать вручную.",
    "Invoice number already exists! Please confirm to save anyway.": "Номер счета-фактуры уже существует! Пожалуйста, подтверди, чтобы сохранить его в любом случае.",
    "Error in data": "Ошибка в данных",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Расчетный период еще идет. После составления счета в данном периоде новые задачи не учитываются.",
    "Creation date": "Дата создания",
    "{0} days after": "{0} дней после",
    "{0} day after": "{0} день после",
    "right away when": "сразу же, когда",
    "start date": "дата начала",
    "due date": "срок выполнения",
    "finished": "завершено",
    "Entries count": "Количество проводок",
    "Entries excluding sales": "Проводки без учета продаж",
    "Entries excluding bank": "Проводки без учета банка",
    "Entries excluding documents": "Проводки, исключающие документы",
    "Documents (sales and purchases)": "Документы (продажи и покупки)",
    "Cash entries": "Кассовые проводки",
    "VAT entries": "Проводки по НДС",
    "Stock entries": "Записи о запасах",
    "Sale entries": "Записи о продаже",
    "Purchase entries": "Записи о покупках",
    "Bank entries": "Банковские проводки",
    "Ledger entries": "Генеральные проводки",
    "Depreciation entries": "Амортизационные проводки",
    "Entry lines count": "Количество проводок",
    "Company owner": "Владелец компании",
    "Activity": "Активность",
    "Oldest first": "Сначала старые",
    "Newest first": "Сначала новые",
    "Quantity as time": "Количество как время",
    "Quantity as number": "Количество как число",
    "Quantity as time in number format": "Количество как время в формате числа",
    "No rounding": "Не округляется",
    "min": "мин",
    "hour": "час",
    "Last day of month": "В последний день месяца",
    "Invoice line": "Строка счета",
    "Task time total (per member)": "Общее время выполнения задания (на одного участника)",
    "Time entry": "Ввод времени",
    "Task finish date": "Дата завершения задания",
    "Create separately": "Создавай отдельно",
    "Merge into one": "Объединить",
    "No minimum": "Минимум отсутствует",
    "{0} minute": "{0} минута",
    "{0} minutes": "{0} минуты",
    "{0} hour": "{0} час",
    "{0} hours": "{0} часов",
    "English": "Английский",
    "Estonian": "Эстонский",
    "Danish": "Датский",
    "Lithuanian": "Литовский",
    "Russian": "Русский",
    "Finnish": "Финский",
    "Swedish": "Шведский",
    "Norwegian": "Норвежский",
    "Latvian": "Латышский",
    "Bulgarian": "Болгарский",
    "German": "Немецкий",
    "Spanish": "Испанский",
    "Polish": "Польский",
    "Field: ": "Поле: ",
    "Normal hours": "Обычные часы",
    "Year": "Год",
    "Estonia": "Эстония",
    "Finland": "Финляндия",
    "Poland": "Польша",
    "Connection successful!": "Подключение прошло успешно!",
    "User": "Пользователь",
    "None": "Нет",
    "Error!": "Ошибка!",
    "Pending": "В ожидании",
    "Finished": "Завершено",
    "Text": "Текст",
    "Choice": "Вариант",
    "Yes/No": "Да/Нет",
    "Integer": "Целое число",
    "Multiple choice": "Множественный выбор",
    "URL": "URL",
    "Multiple users": "Несколько пользователей",
    "Multiline text": "Многострочный текст",
    "Must be a integer": "Значение должно быть integer",
    "Must be a date": "Укажите дату",
    "Must be a valid e-mail address": "Должен быть действительный e-mail",
    "Unknown choice": "Неизвестный выбор",
    "Some errors occurred:": "Произошли некоторые ошибки:",
    "Unknown network error": "Неизвестная ошибка сети",
    "Could not connect to the service": "Не удалось подключиться к сервису",
    "Reload this page": "Перезагрузить страницу",
    "Invoice paid": "Счет оплачен",
    "Annulled": "Аннулировано",
    "Processing": "Обработка",
    "You are about to deactivate this app.": "Ты собираешься деактивировать это приложение.",
    "You are about to disconnect this app.": "Ты собираешься отключить это приложение.",
    "Do you also want to activate billing to get the most out of Uku?": "Включить создание счетов, чтобы использовать Uku по максимуму?",
    "Invoice": "Счет",
    "Clients - Monitoring": "Клиенты - мониторинг",
    "Links": "Ссылки",
    "New template": "Новый шаблон",
    "Import Clients from Excel": "Импорт клиентов из Excel",
    "Importer": "Импортер",
    "Import clients from Excel": "Импорт клиентов из Excel",
    "Account settings": "Настройки аккаунта",
    "Empty": "Пусто",
};
export default translations